"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8285,69],{

/***/ 27602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LightboxModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_image_lightbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92879);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94581);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42287);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);







function LightboxModalStyles() {
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var isRTL = theme.direction === "rtl";
    var ICON_SIZE = 32;
    var ICON_COLOR = theme.palette.grey[600].replace("#", "");
    var getIcon = function(icon) {
        return "url(https://api.iconify.design/carbon/".concat(icon, ".svg?color=%23").concat(ICON_COLOR, "&width=").concat(ICON_SIZE, "&height=").concat(ICON_SIZE, ")");
    };
    var Icon = function(icon) {
        return {
            opacity: 1,
            alignItems: "center",
            display: "inline-flex",
            justifyContent: "center",
            backgroundImage: "unset",
            backgroundColor: "transparent",
            transition: theme.transitions.create("opacity"),
            "&:before": {
                display: "block",
                width: ICON_SIZE,
                height: ICON_SIZE,
                content: getIcon(icon)
            },
            "&:hover": {
                opacity: 0.72
            }
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        styles: {
            "& .ReactModalPortal": {
                "& .ril__outer": {
                    backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .Fq)(theme.palette.grey[900], 0.96)
                },
                // Toolbar
                "& .ril__toolbar": {
                    height: "auto !important",
                    padding: theme.spacing(2, 3),
                    backgroundColor: "transparent"
                },
                "& .ril__toolbarLeftSide": {
                    display: "none"
                },
                "& .ril__toolbarRightSide": {
                    height: "auto !important",
                    padding: 0,
                    flexGrow: 1,
                    display: "flex",
                    alignItems: "center",
                    "& li": {
                        display: "flex",
                        alignItems: "center"
                    },
                    "& li:first-of-type": {
                        flexGrow: 1
                    },
                    "& li:not(:first-of-type)": {
                        width: 40,
                        height: 40,
                        justifyContent: "center",
                        marginLeft: theme.spacing(2)
                    }
                },
                // Button
                "& button:focus": {
                    outline: "none"
                },
                "& .ril__toolbarRightSide button": {
                    width: "100%",
                    height: "100%",
                    "&.ril__zoomInButton": Icon("zoom-in"),
                    "&.ril__zoomOutButton": Icon("zoom-out"),
                    "&.ril__closeButton": Icon("close")
                },
                "& .ril__navButtons": {
                    padding: theme.spacing(3),
                    "&.ril__navButtonPrev": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        right: "auto",
                        left: theme.spacing(2)
                    }, Icon(isRTL ? "arrow-right" : "arrow-left")),
                    "&.ril__navButtonNext": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        left: "auto",
                        right: theme.spacing(2)
                    }, Icon(isRTL ? "arrow-left" : "arrow-right"))
                }
            }
        }
    });
}
function LightboxModal(_param) {
    var images = _param.images, photoIndex = _param.photoIndex, setPhotoIndex = _param.setPhotoIndex, isOpen = _param.isOpen, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "images",
        "photoIndex",
        "setPhotoIndex",
        "isOpen"
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        isOpen
    ]);
    var showIndex = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        variant: "subtitle2",
        children: "".concat(photoIndex + 1, " / ").concat(images.length)
    });
    var toolbarButtons = [
        showIndex
    ];
    var customStyles = {
        overlay: {
            zIndex: 9999
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LightboxModalStyles, {}),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_image_lightbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                animationDuration: 160,
                nextSrc: images[(photoIndex + 1) % images.length],
                prevSrc: images[(photoIndex + images.length - 1) % images.length],
                onMovePrevRequest: function() {
                    return setPhotoIndex((photoIndex + images.length - 1) % images.length);
                },
                onMoveNextRequest: function() {
                    return setPhotoIndex((photoIndex + 1) % images.length);
                },
                toolbarButtons: toolbarButtons,
                reactModalStyle: customStyles
            }, other))
        ]
    });
}


/***/ }),

/***/ 59639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Markdown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96481);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31192);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40549);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50122);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97349);






// markdown plugins

// next

// @mui


//

// ----------------------------------------------------------------------
var MarkdownStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    var isLight = theme.palette.mode === "light";
    var _obj;
    return {
        // p
        "& p": {
            whiteSpace: "pre-line"
        },
        // List
        "& ul, & ol": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, theme.typography.body1), {
            paddingLeft: theme.spacing(2),
            "& li": {
                lineHeight: 2
            }
        }),
        // Blockquote
        "& blockquote": (_obj = {
            lineHeight: 1.5,
            fontSize: "1.5em",
            margin: "40px auto",
            position: "relative",
            fontFamily: "Georgia, serif",
            padding: theme.spacing(3, 3, 3, 8),
            borderRadius: Number(theme.shape.borderRadius) * 2,
            backgroundColor: theme.palette.background.neutral,
            color: "".concat(theme.palette.text.secondary, " !important")
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("md"), {
            width: "80%"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, "& p, & span", {
            marginBottom: "0 !important",
            fontSize: "inherit !important",
            fontFamily: "Georgia, serif !important",
            color: "".concat(theme.palette.text.secondary, " !important")
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, "&:before", {
            left: 16,
            top: -8,
            display: "block",
            fontSize: "3em",
            content: '"\\201C"',
            position: "absolute",
            color: theme.palette.text.disabled
        }), _obj),
        // Code Block
        "& pre, & pre > code": {
            fontSize: 16,
            overflowX: "auto",
            whiteSpace: "pre",
            padding: theme.spacing(2),
            color: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            backgroundColor: isLight ? theme.palette.grey[900] : theme.palette.grey[50016]
        },
        "& code": {
            fontSize: 14,
            borderRadius: 4,
            whiteSpace: "pre",
            padding: theme.spacing(0.2, 0.5),
            color: theme.palette.warning[isLight ? "darker" : "lighter"],
            backgroundColor: theme.palette.warning[isLight ? "lighter" : "darker"],
            "&.hljs": {
                padding: 0,
                backgroundColor: "transparent"
            }
        }
    };
});
// ----------------------------------------------------------------------
function Markdown(_param) {
    var other = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MarkdownStyle, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_8__/* .ReactMarkdown */ .D, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            rehypePlugins: [
                rehype_raw__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z
            ],
            components: components
        }, other))
    });
}
// ----------------------------------------------------------------------
var components = {
    h1: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h1"
        }, props));
    },
    h2: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h2"
        }, props));
    },
    h3: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h3"
        }, props));
    },
    h4: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h4"
        }, props));
    },
    h5: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h5"
        }, props));
    },
    h6: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: "h6"
        }, props));
    },
    hr: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            sx: {
                my: 3
            }
        }, props));
    },
    br: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
            style: {
                display: "block",
                margin: "15px 0",
                content: "''"
            }
        });
    },
    img: function(_param) /*#__PURE__*/ {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            alt: props.alt,
            ratio: "16/9",
            sx: {
                borderRadius: 2,
                my: 5
            }
        }, props));
    },
    a: function(_param) {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _param);
        return props.href.includes("http") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            target: "_blank",
            rel: "noopener"
        }, props)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: props.href,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                children: props.children
            }))
        });
    }
};


/***/ }),

/***/ 77645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);





var Typewriter = function(param) {
    var input = param.input, renderText = param.renderText, _styleOverPropsForCursor = param.styleOverPropsForCursor, styleOverPropsForCursor = _styleOverPropsForCursor === void 0 ? {} : _styleOverPropsForCursor, _styleOverPropsForText = param.styleOverPropsForText, styleOverPropsForText = _styleOverPropsForText === void 0 ? {} : _styleOverPropsForText, _hideCursor = param.hideCursor, hideCursor = _hideCursor === void 0 ? false : _hideCursor, _speed = param.speed, speed = _speed === void 0 ? 20 : _speed;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), text = ref[0], setText = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), index = ref1[0], setIndex = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), showCursor = ref2[0], setShowCursor = ref2[1];
    var speedForCursor = speed * 25;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timerID = setInterval(function() {
            if (index < input.length) {
                setText(function(prevText) {
                    return prevText + input[index];
                });
                setIndex(function(prevIndex) {
                    return prevIndex + 1;
                });
            } else {
                clearInterval(timerID);
            }
        }, speed);
        return function() {
            return clearInterval(timerID);
        };
    }, [
        input,
        index,
        speed
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timerID = setInterval(function() {
            setShowCursor(function(prevShowCursor) {
                return !prevShowCursor;
            });
        }, speedForCursor);
        return function() {
            return clearInterval(timerID);
        };
    }, [
        speedForCursor
    ]);
    var ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                variant: "body2",
                sx: {
                    color: "common.white",
                    whiteSpace: "pre-line"
                }
            }, styleOverPropsForText), {
                children: (ref3 = renderText === null || renderText === void 0 ? void 0 : renderText(text)) !== null && ref3 !== void 0 ? ref3 : text
            })),
            hideCursor ? null : text.length !== input.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, styleOverPropsForCursor), {
                variant: "body2",
                style: {
                    opacity: showCursor ? 1 : 0
                },
                children: "|"
            }))
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Typewriter);


/***/ }),

/***/ 23770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cU": function() { return /* reexport */ CarouselArrowIndex; },
  "ZP": function() { return /* binding */ carousel; }
});

// UNUSED EXPORTS: CarouselArrows, CarouselDots

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(40549);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
;// CONCATENATED MODULE: ./src/components/carousel/CarouselDots.tsx
/* eslint-disable react/jsx-no-useless-fragment */ // @mui





var StyledRoot = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "rounded";
    }
})(function(param) {
    var rounded = param.rounded, theme = param.theme;
    return {
        zIndex: 9,
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.primary.main,
        "& li": {
            width: 18,
            height: 18,
            opacity: 0.32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            "&.slick-active": (0,src_object_spread/* default */.Z)({
                opacity: 1
            }, rounded && {
                "& span": {
                    width: 16,
                    borderRadius: 6
                }
            })
        }
    };
});
var StyledDot = (0,styled/* default */.ZP)("span")(function(param) {
    var theme = param.theme;
    return {
        width: 8,
        height: 8,
        borderRadius: "50%",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.short
        })
    };
});
function CarouselDots(props) {
    var rounded = (props === null || props === void 0 ? void 0 : props.rounded) || false;
    var sx = props === null || props === void 0 ? void 0 : props.sx;
    return {
        appendDots: function(dots) {
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx(StyledRoot, _object_spread_props(_object_spread({
                    component: "ul",
                    rounded: rounded,
                    sx: sx
                }, props), {
                    children: dots
                }))
            });
        },
        customPaging: function() {
            return /*#__PURE__*/ _jsx(Stack, {
                component: "div",
                alignItems: "center",
                justifyContent: "center",
                sx: {
                    width: 1,
                    height: 1
                },
                children: /*#__PURE__*/ _jsx(StyledDot, {
                    sx: {
                        bgcolor: "currentColor"
                    }
                })
            });
        }
    };
}

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./src/components/Iconify.tsx
var Iconify = __webpack_require__(42445);
;// CONCATENATED MODULE: ./src/components/carousel/Icon.tsx



function Icon_LeftIcon(param) {
    var _icon = param.icon, icon = _icon === void 0 ? "eva:arrow-ios-forward-fill" : _icon, isRTL = param.isRTL;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: icon,
        sx: (0,src_object_spread/* default */.Z)({
            width: 20,
            height: 20,
            transform: " scaleX(-1)"
        }, isRTL && {
            transform: " scaleX(1)"
        })
    });
}
function Icon_RightIcon(param) {
    var _icon = param.icon, icon = _icon === void 0 ? "eva:arrow-ios-forward-fill" : _icon, isRTL = param.isRTL;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
        icon: icon,
        sx: (0,src_object_spread/* default */.Z)({
            width: 20,
            height: 20
        }, isRTL && {
            transform: " scaleX(-1)"
        })
    });
}

;// CONCATENATED MODULE: ./src/components/carousel/CarouselArrows.tsx
// @mui






//

var StyledIconButton = (0,styled/* default */.ZP)(IconButton/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "filled" && prop !== "hasChildren" && prop !== "shape";
    }
})(function(param) {
    var filled = param.filled, shape = param.shape, hasChildren = param.hasChildren, theme = param.theme;
    return (0,src_object_spread/* default */.Z)({
        color: "inherit",
        transition: theme.transitions.create("all", {
            duration: theme.transitions.duration.shorter
        })
    }, shape === "rounded" && {
        borderRadius: Number(theme.shape.borderRadius) * 1.5
    }, !filled && {
        opacity: 0.48,
        "&:hover": {
            opacity: 1
        }
    }, filled && {
        color: (0,colorManipulator/* alpha */.Fq)(theme.palette.common.white, 0.8),
        backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[900], 0.48),
        "&:hover": {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.grey[900]
        }
    }, hasChildren && {
        zIndex: 9,
        top: "50%",
        position: "absolute",
        marginTop: theme.spacing(-2.5)
    });
});
function CarouselArrows(_param) {
    var _shape = _param.shape, shape = _shape === void 0 ? "circular" : _shape, _filled = _param.filled, filled = _filled === void 0 ? false : _filled, icon = _param.icon, onNext = _param.onNext, onPrevious = _param.onPrevious, children = _param.children, leftButtonProps = _param.leftButtonProps, rightButtonProps = _param.rightButtonProps, sx = _param.sx, other = _object_without_properties(_param, [
        "shape",
        "filled",
        "icon",
        "onNext",
        "onPrevious",
        "children",
        "leftButtonProps",
        "rightButtonProps",
        "sx"
    ]);
    var theme = useTheme();
    var isRTL = theme.direction === "rtl";
    var hasChildren = !!children;
    if (hasChildren) {
        return /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({
            sx: sx
        }, other), {
            children: [
                /*#__PURE__*/ _jsx(StyledIconButton, _object_spread_props(_object_spread({
                    filled: filled,
                    shape: shape,
                    hasChildren: !!children,
                    onClick: onPrevious
                }, leftButtonProps), {
                    sx: _object_spread({
                        left: 16
                    }, leftButtonProps === null || leftButtonProps === void 0 ? void 0 : leftButtonProps.sx),
                    children: /*#__PURE__*/ _jsx(LeftIcon, {
                        icon: icon,
                        isRTL: isRTL
                    })
                })),
                children,
                /*#__PURE__*/ _jsx(StyledIconButton, _object_spread_props(_object_spread({
                    filled: filled,
                    shape: shape,
                    hasChildren: !!children,
                    onClick: onNext
                }, rightButtonProps), {
                    sx: _object_spread({
                        right: 16
                    }, rightButtonProps === null || rightButtonProps === void 0 ? void 0 : rightButtonProps.sx),
                    children: /*#__PURE__*/ _jsx(RightIcon, {
                        icon: icon,
                        isRTL: isRTL
                    })
                }))
            ]
        }));
    }
    return /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({
        direction: "row",
        alignItems: "center",
        display: "inline-flex",
        sx: sx
    }, other), {
        children: [
            /*#__PURE__*/ _jsx(StyledIconButton, _object_spread_props(_object_spread({
                filled: filled,
                shape: shape,
                onClick: onPrevious
            }, leftButtonProps), {
                children: /*#__PURE__*/ _jsx(LeftIcon, {
                    icon: icon,
                    isRTL: isRTL
                })
            })),
            /*#__PURE__*/ _jsx(StyledIconButton, _object_spread_props(_object_spread({
                filled: filled,
                shape: shape,
                onClick: onNext
            }, rightButtonProps), {
                children: /*#__PURE__*/ _jsx(RightIcon, {
                    icon: icon,
                    isRTL: isRTL
                })
            }))
        ]
    }));
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var styles_useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/utils/cssStyles.ts
var cssStyles = __webpack_require__(20727);
;// CONCATENATED MODULE: ./src/components/carousel/CarouselArrowIndex.tsx








// ----------------------------------------------------------------------
var CarouselArrowIndex_StyledRoot = (0,styled/* default */.ZP)(Box/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgBlur({
        opacity: 0.48,
        color: theme.palette.grey[900]
    })), {
        zIndex: 9,
        display: "inline-flex",
        alignItems: "center",
        position: "absolute",
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        padding: theme.spacing(0.25),
        color: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius
    });
});
var CarouselArrowIndex_StyledIconButton = (0,styled/* default */.ZP)(IconButton/* default */.Z)({
    width: 28,
    height: 28,
    padding: 0,
    opacity: 0.48,
    "&:hover": {
        opacity: 1
    }
});
function CarouselArrowIndex(_param) {
    var index = _param.index, total = _param.total, onNext = _param.onNext, onPrevious = _param.onPrevious, icon = _param.icon, sx = _param.sx, other = (0,src_object_without_properties/* default */.Z)(_param, [
        "index",
        "total",
        "onNext",
        "onPrevious",
        "icon",
        "sx"
    ]);
    var theme = (0,styles_useTheme/* default */.Z)();
    var isRTL = theme.direction === "rtl";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CarouselArrowIndex_StyledRoot, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        sx: sx
    }, other), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrowIndex_StyledIconButton, {
                color: "inherit",
                onClick: onPrevious,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_LeftIcon, {
                    icon: icon,
                    isRTL: isRTL
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                variant: "subtitle2",
                component: "span",
                sx: {
                    mx: 0.25
                },
                children: [
                    index + 1,
                    "/",
                    total
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselArrowIndex_StyledIconButton, {
                color: "inherit",
                onClick: onNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_RightIcon, {
                    icon: icon,
                    isRTL: isRTL
                })
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/components/carousel/index.ts




/* harmony default export */ var carousel = (lib/* default */.Z);


/***/ }),

/***/ 41923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ renderOptionFunc; },
/* harmony export */   "w": function() { return /* binding */ RichTextStyleWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86437);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7906);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53252);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53816);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50122);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29430);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97349);
/* harmony import */ var _theme_palette__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78187);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22004);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  p {\n    font-size: inherit;\n    white-space: pre-line;\n  }\n\n  // List\n  & ul,\n  & ol {\n    padding-left: 1.25rem;\n    & li {\n      line-height: 2px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0px 0px 0.75em;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 1.5;\n  font-size: 1.5em;\n  margin: 40px auto;\n  position: relative;\n  font-family: Georgia, serif;\n  padding: 3rem 3.5rem 3rem 4.5rem;\n  border-radius: 16px;\n  background-color: ",
        ";\n  color: ",
        " !important;\n  width: 100%;\n  display: block;\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p {\n    margin: 0 !important;\n  }\n\n  &:before {\n    left: 30px;\n    top: 10px;\n    display: block;\n    position: absolute;\n    font-size: 3em;\n    content: '\\201C';\n    position: absolute;\n    color: ",
        ";\n  }\n  @media (max-width: 768px) {\n    width: 100%;\n    padding: 1rem;\n  }\n"
    ], [
        "\n  line-height: 1.5;\n  font-size: 1.5em;\n  margin: 40px auto;\n  position: relative;\n  font-family: Georgia, serif;\n  padding: 3rem 3.5rem 3rem 4.5rem;\n  border-radius: 16px;\n  background-color: ",
        ";\n  color: ",
        " !important;\n  width: 100%;\n  display: block;\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p {\n    margin: 0 !important;\n  }\n\n  &:before {\n    left: 30px;\n    top: 10px;\n    display: block;\n    position: absolute;\n    font-size: 3em;\n    content: '\\\\201C';\n    position: absolute;\n    color: ",
        ";\n  }\n  @media (max-width: 768px) {\n    width: 100%;\n    padding: 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: scroll;\n  border-collapse: collapse;\n  width: 100%;\n  border: 1px solid ",
        ";\n  margin: 15px 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:hover {\n    background-color: ",
        ";\n    > td {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 150px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









var ReactViewer = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return __webpack_require__.e(/* import() */ 1285).then(__webpack_require__.t.bind(__webpack_require__, 51285, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51285)
            ];
        }
    },
    ssr: false
});
var RichTextStyleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-13092476-0"
})(_templateObject());
var StyledImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_components_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-13092476-1"
})(_templateObject1());
var StyledBlockquote = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].blockquote.withConfig */ .ZP.blockquote.withConfig({
    componentId: "sc-13092476-2"
})(_templateObject2(), _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.background.neutral */ .ZP.light.background.neutral, _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.text.primary */ .ZP.light.text.primary, _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.text.disabled */ .ZP.light.text.disabled);
var StyledTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-13092476-3"
})(_templateObject3(), _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.grey[500] */ .ZP.light.grey[500]);
var StyledTableCell = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-13092476-4"
})(_templateObject4(), _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.grey[500] */ .ZP.light.grey[500]);
var StyledTableRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-13092476-5"
})(_templateObject5(), _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.grey[200] */ .ZP.light.grey[200], _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.grey[200] */ .ZP.light.grey[200]);
var TableHeadCell = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(StyledTableCell).withConfig({
    componentId: "sc-13092476-6"
})(_templateObject6(), _theme_palette__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light.grey[400] */ .ZP.light.grey[400]);
var isVideoFile = function(url) {
    var testUrl = url === null || url === void 0 ? void 0 : url.toLowerCase();
    if (testUrl === null || testUrl === void 0 ? void 0 : testUrl.includes("mp4")) return true;
    if (testUrl === null || testUrl === void 0 ? void 0 : testUrl.includes("mov")) return true;
    return false;
};
var ReactViewerComponent = function(props) {
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
    var asset = props.asset;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), displayImageSrc = ref[0], setDisplayImageSrc = ref[1];
    var _url;
    var isVideo = isVideoFile((_url = asset.url) !== null && _url !== void 0 ? _url : "");
    if (isVideo) {
        var _url1;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            loop: true,
            width: "100%",
            height: "50vh",
            url: (_url1 = asset.url) !== null && _url1 !== void 0 ? _url1 : undefined,
            controls: true
        });
    }
    var _url2, _url3, _description, _url4;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImage, {
                onClick: function() {
                    return setDisplayImageSrc((_url2 = asset.url) !== null && _url2 !== void 0 ? _url2 : "");
                },
                src: (_url3 = asset.url) !== null && _url3 !== void 0 ? _url3 : "",
                alt: (_description = asset.description) !== null && _description !== void 0 ? _description : "",
                ratio: "16/9",
                sx: {
                    borderRadius: 1,
                    my: 5
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReactViewer, {
                zIndex: theme.zIndex.modal,
                showTotal: false,
                changeable: false,
                noNavbar: true,
                visible: !!displayImageSrc,
                onClose: function() {
                    return setDisplayImageSrc("");
                },
                onMaskClick: function() {
                    return setDisplayImageSrc("");
                },
                images: [
                    {
                        src: (_url4 = asset.url) !== null && _url4 !== void 0 ? _url4 : ""
                    }
                ]
            })
        ]
    });
};
var getYoutubeVideoID = function(url) {
    var match = url.match(/.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/);
    if (match !== null && match[1].length === 11) {
        return match[1];
    } else {
        return "";
    }
};
var renderOptionFunc = function(asset) {
    var _obj;
    return {
        renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ASSET, function(node) {
            var ref;
            var id = node.data.target.sys.id;
            var matchedAsset = asset === null || asset === void 0 ? void 0 : (ref = asset.block) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.sys.id) === id;
            });
            if (matchedAsset) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ReactViewerComponent, {
                    asset: matchedAsset
                });
            }
            return null;
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_1, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h1",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_2, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h2",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_3, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h3",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_4, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h4",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_5, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h5",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_6, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 0.75em"
                },
                variant: "h6",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.PARAGRAPH, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                style: {
                    margin: "0px 0px 1.5em"
                },
                variant: "body1",
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTable, {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_HEADER_CELL, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TableHeadCell, {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_CELL, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTableCell, {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_ROW, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTableRow, {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.UL_LIST, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.OL_LIST, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ol", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.LIST_ITEM, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.QUOTE, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBlockquote, {
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HR, function() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                sx: {
                    my: 3
                }
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.HYPERLINK, function(node) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            if ((node === null || node === void 0 ? void 0 : (ref = node.data) === null || ref === void 0 ? void 0 : ref.uri.toLowerCase().indexOf(".png")) !== -1 || (node === null || node === void 0 ? void 0 : (ref1 = node.data) === null || ref1 === void 0 ? void 0 : ref1.uri.toLowerCase().indexOf(".jpg")) !== -1 || (node === null || node === void 0 ? void 0 : (ref2 = node.data) === null || ref2 === void 0 ? void 0 : ref2.uri.toLowerCase().indexOf(".jpeg")) !== -1 || (node === null || node === void 0 ? void 0 : (ref3 = node.data) === null || ref3 === void 0 ? void 0 : ref3.uri.toLowerCase().indexOf(".gif")) !== -1) {
                var ref8;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImage, {
                    src: node === null || node === void 0 ? void 0 : (ref8 = node.data) === null || ref8 === void 0 ? void 0 : ref8.uri
                });
            }
            if ((node === null || node === void 0 ? void 0 : (ref4 = node.data) === null || ref4 === void 0 ? void 0 : ref4.uri.indexOf("youtube.com/embed")) !== -1 || (node === null || node === void 0 ? void 0 : (ref5 = node.data) === null || ref5 === void 0 ? void 0 : ref5.uri.indexOf("youtube.com/watch")) !== -1) {
                var ref9;
                var videoId = getYoutubeVideoID(node === null || node === void 0 ? void 0 : (ref9 = node.data) === null || ref9 === void 0 ? void 0 : ref9.uri);
                var url = node.data.uri.indexOf("youtube.com/embed") !== -1 ? node.data.uri : "https://www.youtube.com/embed/".concat(videoId);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        position: "relative",
                        paddingTop: "56.25%"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
                        width: "100%",
                        height: "100%",
                        src: url,
                        title: url,
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0
                        },
                        frameBorder: "0",
                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                        allowFullScreen: true
                    })
                });
            }
            var domains = [
                "youtube.com/embed",
                "app.tango.us/app/embed"
            ];
            var isMatch = domains.some(function(domain) {
                var ref, ref1;
                return node === null || node === void 0 ? void 0 : (ref = node.data) === null || ref === void 0 ? void 0 : (ref1 = ref.uri) === null || ref1 === void 0 ? void 0 : ref1.includes(domain);
            });
            if (isMatch) {
                var ref10, ref11;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        position: "relative",
                        paddingTop: "56.25%"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
                        width: "100%",
                        height: "100%",
                        src: node === null || node === void 0 ? void 0 : (ref10 = node.data) === null || ref10 === void 0 ? void 0 : ref10.uri,
                        title: node === null || node === void 0 ? void 0 : (ref11 = node.data) === null || ref11 === void 0 ? void 0 : ref11.uri,
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0
                        },
                        frameBorder: "0",
                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                        allowFullScreen: true
                    })
                });
            }
            if ((node === null || node === void 0 ? void 0 : (ref6 = node.data) === null || ref6 === void 0 ? void 0 : ref6.uri.indexOf("www.youtube.com/watch")) !== -1) {
                var ref12;
                var ref13;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        position: "relative",
                        paddingTop: "56.25%"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        width: "100%",
                        height: "100%",
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0
                        },
                        url: (ref13 = node === null || node === void 0 ? void 0 : (ref12 = node.data) === null || ref12 === void 0 ? void 0 : ref12.uri) !== null && ref13 !== void 0 ? ref13 : undefined,
                        controls: true
                    })
                });
            }
            if (node === null || node === void 0 ? void 0 : (ref7 = node.data) === null || ref7 === void 0 ? void 0 : ref7.uri.includes("https")) {
                var _content = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(node.content, 1), ref14 = _content[0], _value = ref14.value, value = _value === void 0 ? "Link" : _value;
                var _uri;
                var src = (_uri = node.data.uri) !== null && _uri !== void 0 ? _uri : "";
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    style: {
                        textDecoration: "underline"
                    },
                    target: "_blank",
                    rel: "noopener",
                    href: src,
                    children: value
                });
            }
        }), _obj)
    };
};


/***/ }),

/***/ 98968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aN": function() { return /* binding */ PromptSupportingLanguageMap; }
/* harmony export */ });
/* unused harmony exports ImageCreateResponseFormat, ResponseTone, WritingStyle, PromptInterfaceFragmentDoc, VisitorChromeExtensionPromptResponseFragmentDoc, VisitorChromeExtensionPromptResponseWithPromptDetailFragmentDoc, VisitorFetchPromptsDocument, VisitorFetchPromptsForChromeExtensionDocument, VisitorFetchPromptsForChromeExtensionWithPromptDetailDocument, VisitorGeneratePromptDocument, getSdk */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39011);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31230);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment PromptInterface on PromptInterface {\n    id\n    promptHint\n    promptTeaser\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment VisitorChromeExtensionPromptResponse on ChromeExtensionPromptResponse {\n    id\n    title\n    category\n    promptHint\n    promptTeaser\n    createdAt\n    updatedAt\n    statistics {\n      usages\n      views\n      votes\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment VisitorChromeExtensionPromptResponseWithPromptDetail on ChromeExtensionPromptResponse {\n    ...VisitorChromeExtensionPromptResponse\n    prompt\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorFetchPrompts @cached(ttl: 300) {\n    prompts {\n      ...PromptInterface\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorFetchPromptsForChromeExtension @cached(ttl: 300) {\n    promptsForChromeExtension {\n      ...VisitorChromeExtensionPromptResponse\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorFetchPromptsForChromeExtensionWithPromptDetail @cached(ttl: 300) {\n    promptsForChromeExtension {\n      ...VisitorChromeExtensionPromptResponseWithPromptDetail\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query visitorGeneratePrompt(\n    $language: PromptSupportingLanguageMap!\n    $prompt: String!\n    $promptId: String!\n  ) {\n    generatePrompt(prompt: $prompt, promptId: $promptId, language: $language) {\n      id\n      language\n      prompt\n      createResponse {\n        created\n        id\n        model\n        object\n        usage {\n          completion_tokens\n          prompt_tokens\n          total_tokens\n        }\n        choices {\n          finish_reason\n          index\n          text\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var ImageCreateResponseFormat;
(function(ImageCreateResponseFormat) {
    ImageCreateResponseFormat["B64Json"] = "b64_json";
    ImageCreateResponseFormat["Url"] = "url";
})(ImageCreateResponseFormat || (ImageCreateResponseFormat = {}));
var PromptSupportingLanguageMap;
(function(PromptSupportingLanguageMap) {
    PromptSupportingLanguageMap["Arabic"] = "Arabic";
    PromptSupportingLanguageMap["Bulgarian"] = "Bulgarian";
    PromptSupportingLanguageMap["Catalan"] = "Catalan";
    PromptSupportingLanguageMap["Chinese"] = "Chinese";
    PromptSupportingLanguageMap["Czech"] = "Czech";
    PromptSupportingLanguageMap["Danish"] = "Danish";
    PromptSupportingLanguageMap["Dutch"] = "Dutch";
    PromptSupportingLanguageMap["English"] = "English";
    PromptSupportingLanguageMap["Finnish"] = "Finnish";
    PromptSupportingLanguageMap["French"] = "French";
    PromptSupportingLanguageMap["German"] = "German";
    PromptSupportingLanguageMap["Greek"] = "Greek";
    PromptSupportingLanguageMap["Hebrew"] = "Hebrew";
    PromptSupportingLanguageMap["Hindi"] = "Hindi";
    PromptSupportingLanguageMap["Hungarian"] = "Hungarian";
    PromptSupportingLanguageMap["Indonesian"] = "Indonesian";
    PromptSupportingLanguageMap["Italian"] = "Italian";
    PromptSupportingLanguageMap["Japanese"] = "Japanese";
    PromptSupportingLanguageMap["Korean"] = "Korean";
    PromptSupportingLanguageMap["MandarinChinese"] = "MandarinChinese";
    PromptSupportingLanguageMap["Norwegian"] = "Norwegian";
    PromptSupportingLanguageMap["Polish"] = "Polish";
    PromptSupportingLanguageMap["Portuguese"] = "Portuguese";
    PromptSupportingLanguageMap["Romanian"] = "Romanian";
    PromptSupportingLanguageMap["Russian"] = "Russian";
    PromptSupportingLanguageMap["Serbian"] = "Serbian";
    PromptSupportingLanguageMap["Spanish"] = "Spanish";
    PromptSupportingLanguageMap["Swedish"] = "Swedish";
    PromptSupportingLanguageMap["Thai"] = "Thai";
    PromptSupportingLanguageMap["Turkish"] = "Turkish";
    PromptSupportingLanguageMap["Ukrainian"] = "Ukrainian";
    PromptSupportingLanguageMap["Vietnamese"] = "Vietnamese";
})(PromptSupportingLanguageMap || (PromptSupportingLanguageMap = {}));
var ResponseTone;
(function(ResponseTone) {
    ResponseTone["Authoritative"] = "Authoritative";
    ResponseTone["Clinical"] = "Clinical";
    ResponseTone["Cold"] = "Cold";
    ResponseTone["Confident"] = "Confident";
    ResponseTone["Cynical"] = "Cynical";
    ResponseTone["Emotional"] = "Emotional";
    ResponseTone["Empathetic"] = "Empathetic";
    ResponseTone["Formal"] = "Formal";
    ResponseTone["Friendly"] = "Friendly";
    ResponseTone["Humorous"] = "Humorous";
    ResponseTone["Informal"] = "Informal";
    ResponseTone["Ironic"] = "Ironic";
    ResponseTone["Label"] = "Label";
    ResponseTone["Optimistic"] = "Optimistic";
    ResponseTone["Pessimistic"] = "Pessimistic";
    ResponseTone["Playful"] = "Playful";
    ResponseTone["Sarcastic"] = "Sarcastic";
    ResponseTone["Serious"] = "Serious";
    ResponseTone["Sympathetic"] = "Sympathetic";
    ResponseTone["Tentative"] = "Tentative";
    ResponseTone["Warm"] = "Warm";
})(ResponseTone || (ResponseTone = {}));
var WritingStyle;
(function(WritingStyle) {
    WritingStyle["Academic"] = "Academic";
    WritingStyle["Analytical"] = "Analytical";
    WritingStyle["Argumentative"] = "Argumentative";
    WritingStyle["Conversational"] = "Conversational";
    WritingStyle["Creative"] = "Creative";
    WritingStyle["Critical"] = "Critical";
    WritingStyle["Descriptive"] = "Descriptive";
    WritingStyle["Epigrammatic"] = "Epigrammatic";
    WritingStyle["Epistolary"] = "Epistolary";
    WritingStyle["Expository"] = "Expository";
    WritingStyle["Informative"] = "Informative";
    WritingStyle["Instructive"] = "Instructive";
    WritingStyle["Journalistic"] = "Journalistic";
    WritingStyle["Label"] = "Label";
    WritingStyle["Metaphorical"] = "Metaphorical";
    WritingStyle["Narrative"] = "Narrative";
    WritingStyle["Persuasive"] = "Persuasive";
    WritingStyle["Poetic"] = "Poetic";
    WritingStyle["Satirical"] = "Satirical";
    WritingStyle["Technical"] = "Technical";
})(WritingStyle || (WritingStyle = {}));
var PromptInterfaceFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject());
var VisitorChromeExtensionPromptResponseFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject1());
var VisitorChromeExtensionPromptResponseWithPromptDetailFragmentDoc = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject2(), VisitorChromeExtensionPromptResponseFragmentDoc);
var VisitorFetchPromptsDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject3(), PromptInterfaceFragmentDoc);
var VisitorFetchPromptsForChromeExtensionDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject4(), VisitorChromeExtensionPromptResponseFragmentDoc);
var VisitorFetchPromptsForChromeExtensionWithPromptDetailDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject5(), VisitorChromeExtensionPromptResponseWithPromptDetailFragmentDoc);
var VisitorGeneratePromptDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject6());
var defaultWrapper = function(action, _operationName, _operationType) {
    return action();
};
var VisitorFetchPromptsDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorFetchPromptsDocument);
var VisitorFetchPromptsForChromeExtensionDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorFetchPromptsForChromeExtensionDocument);
var VisitorFetchPromptsForChromeExtensionWithPromptDetailDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorFetchPromptsForChromeExtensionWithPromptDetailDocument);
var VisitorGeneratePromptDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .print */ .S)(VisitorGeneratePromptDocument);
function getSdk(client) {
    var withWrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultWrapper;
    return {
        visitorFetchPrompts: function visitorFetchPrompts(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorFetchPromptsDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorFetchPrompts", "query");
        },
        visitorFetchPromptsForChromeExtension: function visitorFetchPromptsForChromeExtension(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorFetchPromptsForChromeExtensionDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorFetchPromptsForChromeExtension", "query");
        },
        visitorFetchPromptsForChromeExtensionWithPromptDetail: function visitorFetchPromptsForChromeExtensionWithPromptDetail(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorFetchPromptsForChromeExtensionWithPromptDetailDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorFetchPromptsForChromeExtensionWithPromptDetail", "query");
        },
        visitorGeneratePrompt: function visitorGeneratePrompt(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(VisitorGeneratePromptDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "visitorGeneratePrompt", "query");
        }
    };
}


/***/ }),

/***/ 29608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ RootStyle; },
/* harmony export */   "k": function() { return /* binding */ TopLandingSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_animate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76843);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40549);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32970);







var TopLandingSection = function(props) {
    var _title = props.title, title = _title === void 0 ? "" : _title, titleColor = props.titleColor, _subtitle = props.subtitle, subtitle = _subtitle === void 0 ? "" : _subtitle, subtitleColor = props.subtitleColor, subtitleFontSize = props.subtitleFontSize;
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    if (title === "" && subtitle === "") return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        sx: {
            textAlign: "center",
            mb: 5
        },
        id: title,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__.m.div, {
                variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_1__/* .varFade */ .EU)().inUp,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "h3",
                    sx: {
                        mb: 2,
                        color: titleColor !== null && titleColor !== void 0 ? titleColor : theme.palette.primary.main
                    },
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__.m.div, {
                variants: (0,_components_animate__WEBPACK_IMPORTED_MODULE_1__/* .varFade */ .EU)().inDown,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "body1",
                    sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        mb: 2,
                        color: subtitleColor !== null && subtitleColor !== void 0 ? subtitleColor : theme.palette.grey[600]
                    }, subtitleFontSize ? {
                        fontSize: subtitleFontSize
                    } : {}),
                    children: subtitle
                })
            })
        ]
    });
};
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme, backgroundColor = param.backgroundColor, backgroundImage = param.backgroundImage;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        backgroundColor: backgroundColor || theme.palette.background.neutral,
        backgroundImage: backgroundImage,
        padding: theme.spacing(10, 2)
    }, theme.breakpoints.up("md"), {
        padding: theme.spacing(12, 0)
    });
});


/***/ }),

/***/ 82290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X0": function() { return /* reexport */ LandingContact; },
  "J7": function() { return /* reexport */ LandingDetailPerson; },
  "B5": function() { return /* reexport */ LandingExperienceTimeline; },
  "Xg": function() { return /* reexport */ LandingFaqList; },
  "LF": function() { return /* reexport */ LandingFeatureList; },
  "wU": function() { return /* reexport */ LandingForm; },
  "K": function() { return /* reexport */ LandingGallery; },
  "Ks": function() { return /* reexport */ LandingHero; },
  "qU": function() { return /* reexport */ LandingPartner; },
  "n9": function() { return /* reexport */ LandingImage; },
  "K9": function() { return /* reexport */ LandingImageList; },
  "TJ": function() { return /* reexport */ LandingMintList; },
  "Uo": function() { return /* reexport */ LandingService; },
  "uY": function() { return /* reexport */ LandingTimer; },
  "Nn": function() { return /* reexport */ LandingVideo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(32970);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(40549);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(27948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(41997);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(99062);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js
var notistack_esm = __webpack_require__(73400);
// EXTERNAL MODULE: ./src/components/Iconify.tsx
var Iconify = __webpack_require__(42445);
// EXTERNAL MODULE: ./src/components/animate/index.ts + 12 modules
var animate = __webpack_require__(76843);
// EXTERNAL MODULE: ./src/components/Typewriter.tsx
var Typewriter = __webpack_require__(77645);
// EXTERNAL MODULE: ./src/components/Markdown.tsx
var Markdown = __webpack_require__(59639);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./src/generated/graphql.tsx + 6 modules
var graphql = __webpack_require__(25168);
// EXTERNAL MODULE: ./src/services/prompts/utils.ts
var utils = __webpack_require__(76271);
// EXTERNAL MODULE: ./src/routes/paths.ts
var paths = __webpack_require__(96259);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/lab/LoadingButton/LoadingButton.js + 1 modules
var LoadingButton = __webpack_require__(31812);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(20474);
// EXTERNAL MODULE: ./node_modules/ts-enum-util/dist/es/index.js + 9 modules
var es = __webpack_require__(54586);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/lodash/sampleSize.js
var sampleSize = __webpack_require__(42404);
var sampleSize_default = /*#__PURE__*/__webpack_require__.n(sampleSize);
;// CONCATENATED MODULE: ./src/sections/landing/LandingHero.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  align-items: center;\n  grid-gap: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





















var RootStyle = (0,styled/* default */.ZP)(motion_minimal.m.div)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        position: "relative"
    }, theme.breakpoints.up("md"), {
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        display: "flex",
        position: "fixed",
        alignItems: "center"
    });
});
var ContentStyle = (0,styled/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, (0,_object_spread/* default */.Z)({
        spacing: 5
    }, props));
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        zIndex: 10,
        maxWidth: 600,
        margin: "auto",
        textAlign: "center",
        position: "relative",
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(15)
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        paddingTop: theme.spacing(20),
        paddingBottom: theme.spacing(10)
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        margin: "unset",
        textAlign: "left"
    }), _obj;
});
var HeroOverlayStyle = (0,styled/* default */.ZP)(motion_minimal.m.img)({
    zIndex: -1,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    position: "fixed"
});
var HeroImgStyle = (0,styled/* default */.ZP)(motion_minimal.m.img)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: 8,
        width: "100%",
        margin: "auto",
        position: "absolute"
    }, theme.breakpoints.up("lg"), {
        right: "12%",
        width: "auto",
        height: "33%",
        zIndex: 10
    });
});
var BackgroundVideo = (0,styled/* default */.ZP)(motion_minimal.m.video)(function(param) {
    var theme = param.theme;
    return {
        width: "100vw",
        height: "100vh",
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
        position: "absolute",
        objectFit: "cover"
    };
});
var BackgroundSource = (0,styled/* default */.ZP)(motion_minimal.m.source)(function(param) {
    var theme = param.theme;
    return {};
});
var InputContainer = (0,styled/* default */.ZP)("div")(_templateObject());
var RecommendationInputContainer = (0,styled/* default */.ZP)(motion_minimal.m.div)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "grid",
        gridTemplateColumns: "1fr",
        alignItems: "center",
        gridGap: "10px"
    }, theme.breakpoints.up("md"), {
        display: "flex",
        alignItems: "center",
        gridGap: "10px"
    });
});
var defaultBackgroundOverlay = "/assets/images/overlay.svg";
var defaultDisplayInput = "I am the smartest AI you'll ever meet! I'm here to assist you with anything you need, from answering your questions to helping you complete tasks.\nWhether you're looking for a quick answer to a question or need some guidance with a project, I'm always here to lend a helping hand. And the best part? You don't have to worry about any awkward small talk or judgement, because I'm here to listen and provide you with the best possible response.\nSo go ahead, ask me anything!\n  ";
function LandingHero(props) {
    var _contentfulDataFragment = props.contentfulDataFragment, companyName = _contentfulDataFragment.companyName, featureText = _contentfulDataFragment.featureText, descriptionText = _contentfulDataFragment.descriptionText, callToActionText = _contentfulDataFragment.callToActionText, callToActionHref = _contentfulDataFragment.callToActionHref, backgroundImage = _contentfulDataFragment.backgroundImage, fullWidthBackgroundImageDesktop = _contentfulDataFragment.fullWidthBackgroundImageDesktop, fullWidthBackgroundImageMobile = _contentfulDataFragment.fullWidthBackgroundImageMobile, enableAiTrail = _contentfulDataFragment.enableAiTrail, enableAiTrailDisplayText = _contentfulDataFragment.enableAiTrailDisplayText, enableAiRecommendation = _contentfulDataFragment.enableAiRecommendation, enableAiRecommendationDisplayText = _contentfulDataFragment.enableAiRecommendationDisplayText, sys = _contentfulDataFragment.sys;
    var _contentfulDataForProductSearchTagsFragment;
    var tags = (_contentfulDataForProductSearchTagsFragment = props.contentfulDataForProductSearchTagsFragment) !== null && _contentfulDataForProductSearchTagsFragment !== void 0 ? _contentfulDataForProductSearchTagsFragment : [];
    var router = (0,next_router.useRouter)();
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var ref = (0,react.useState)(""), inputText = ref[0], setInputText = ref[1];
    var ref1 = (0,react.useState)(null), inputTextDesc = ref1[0], setInputTextDesc = ref1[1];
    var ref2 = (0,react.useState)(enableAiTrail ? enableAiTrailDisplayText !== null && enableAiTrailDisplayText !== void 0 ? enableAiTrailDisplayText : defaultDisplayInput : enableAiRecommendation ? enableAiRecommendationDisplayText !== null && enableAiRecommendationDisplayText !== void 0 ? enableAiRecommendationDisplayText : defaultDisplayInput : null), defaultInput = ref2[0], setDefaultInput = ref2[1];
    var ref3 = (0,react.useState)(""), tagsInputText = ref3[0], setTagsInputText = ref3[1];
    var ref4 = (0,react.useState)(""), tagsOutputText = ref4[0], setTagsOutputText = ref4[1];
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useVisitorGeneratePromptWithTagsLazyQuery */.H33)({
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "no-cache",
        onCompleted: function(data) {
            var ref;
            var _text;
            setTagsOutputText((_text = (ref = data.generatePromptWithTags.createResponse) === null || ref === void 0 ? void 0 : ref.choices[0].text) !== null && _text !== void 0 ? _text : "");
        },
        onError: function() {
            enqueueSnackbar("Failed to Chat, Try Later!", {
                variant: "error"
            });
            setTagsOutputText(null);
        }
    }), 2), visitorGeneratePromptWithTags = ref5[0], ref6 = ref5[1], visitorGeneratePromptWithTagsQueryLoading = ref6.loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useVisitorGeneratePromptLazyQuery */.SDW)({
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "no-cache",
        onCompleted: function(data) {
            var ref, ref1, ref2;
            var ref3;
            setInputTextDesc((ref3 = (ref = data.generatePrompt.createResponse) === null || ref === void 0 ? void 0 : (ref1 = ref.choices) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.text) !== null && ref3 !== void 0 ? ref3 : "");
        },
        onError: function() {
            enqueueSnackbar("Failed to Chat, Try Later!", {
                variant: "error"
            });
            setInputTextDesc(null);
        }
    }), 2), visitorGeneratePromptLazyQueryLazy = ref7[0], ref8 = ref7[1], visitorGeneratePromptLazyQueryLoading = ref8.loading;
    var _id, ref9, ref10;
    var allProductSearchTags = (ref10 = tags.map(function(item) {
        return {
            id: (_id = item === null || item === void 0 ? void 0 : item.sys.id) !== null && _id !== void 0 ? _id : "",
            name: (ref9 = item === null || item === void 0 ? void 0 : item.name) !== null && ref9 !== void 0 ? ref9 : ""
        };
    })) !== null && ref10 !== void 0 ? ref10 : [];
    var ref11, ref12;
    var src = isMobile ? (ref11 = fullWidthBackgroundImageMobile === null || fullWidthBackgroundImageMobile === void 0 ? void 0 : fullWidthBackgroundImageMobile.url) !== null && ref11 !== void 0 ? ref11 : defaultBackgroundOverlay : (ref12 = fullWidthBackgroundImageDesktop === null || fullWidthBackgroundImageDesktop === void 0 ? void 0 : fullWidthBackgroundImageDesktop.url) !== null && ref12 !== void 0 ? ref12 : defaultBackgroundOverlay;
    var isVideo = src.includes("mp4");
    var promptAppHref = (0,utils/* formatPromptsPageUrl */.J1)({
        useCase: utils/* UseCase.text */._7.text,
        language: graphql/* PromptSupportingLanguageMap.English */.aNC.English,
        prompt: inputText
    });
    (0,react.useEffect)(function() {
        if (enableAiTrail) {
            router.prefetch(promptAppHref);
        }
    }, []);
    var renderTagText = "Here are the tags that is associate to your questions ".concat(tagsOutputText);
    var isStillFetching = visitorGeneratePromptLazyQueryLoading || visitorGeneratePromptWithTagsQueryLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(animate/* MotionContainer */.NM, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootStyle, {
                children: [
                    isVideo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(BackgroundVideo, {
                        autoPlay: true,
                        loop: true,
                        muted: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundSource, {
                                src: src,
                                type: "video/mp4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundSource, {
                                src: src,
                                type: "video/ogg"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroOverlayStyle, {
                        alt: "overlay",
                        src: src,
                        variants: (0,animate/* varFade */.EU)().in
                    }),
                    (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroImgStyle, {
                        alt: "hero",
                        src: backgroundImage.url,
                        variants: (0,animate/* varFade */.EU)().inUp
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentStyle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                    variants: (0,animate/* varFade */.EU)().inRight,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "h2",
                                        sx: {
                                            color: "common.white"
                                        },
                                        children: [
                                            !!companyName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "span",
                                                variant: "h2",
                                                sx: {
                                                    color: "primary.main"
                                                },
                                                children: companyName
                                            }),
                                            !!featureText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "div",
                                                variant: "h2",
                                                sx: {
                                                    mt: 0.5
                                                },
                                                children: featureText
                                            })
                                        ]
                                    })
                                }),
                                !!descriptionText && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                    variants: (0,animate/* varFade */.EU)().inRight,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            color: "common.white"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* default */.Z, {
                                            children: descriptionText || ""
                                        })
                                    })
                                }),
                                !!callToActionText && !!callToActionHref && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                    variants: (0,animate/* varFade */.EU)().inRight,
                                    children: callToActionHref.startsWith("#") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                        to: callToActionHref.replace("#", ""),
                                        spy: true,
                                        smooth: true,
                                        offset: -80,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            size: "large",
                                            variant: "contained",
                                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                                icon: "eva:flash-fill",
                                                width: 20,
                                                height: 20
                                            }),
                                            children: callToActionText
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        size: "large",
                                        target: callToActionHref.includes("http") ? "_blank" : undefined,
                                        rel: callToActionHref.includes("http") ? "noopener" : undefined,
                                        variant: "contained",
                                        href: callToActionHref,
                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: "eva:flash-fill",
                                            width: 20,
                                            height: 20
                                        }),
                                        children: callToActionText
                                    })
                                }),
                                enableAiTrail && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                                variants: (0,animate/* varFade */.EU)().inRight,
                                                children: (0,es/* $enum */.o6)(utils/* UseCase */._7).getValues().map(function(useCase) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        disabled: useCase !== utils/* UseCase.text */._7.text,
                                                        sx: {
                                                            mr: 1,
                                                            mb: isMobile ? 1 : 0
                                                        },
                                                        size: "large",
                                                        variant: "contained",
                                                        startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                                            icon: "eva:flash-fill",
                                                            width: 20,
                                                            height: 20
                                                        }),
                                                        children: useCase
                                                    }, useCase);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                onChange: function(e) {
                                                    return setInputText(e.target.value);
                                                },
                                                value: inputText,
                                                fullWidth: true,
                                                variant: "outlined"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: promptAppHref,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    href: promptAppHref,
                                                    size: "large",
                                                    variant: "contained",
                                                    children: "Try It!"
                                                })
                                            }),
                                            defaultInput && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typewriter/* default */.Z, {
                                                input: defaultInput
                                            })
                                        ]
                                    })
                                }),
                                enableAiRecommendation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecommendationInputContainer, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    disabled: visitorGeneratePromptWithTagsQueryLoading || visitorGeneratePromptLazyQueryLoading,
                                                    onChange: function(e) {
                                                        return setTagsInputText(e.target.value);
                                                    },
                                                    value: tagsInputText,
                                                    fullWidth: true,
                                                    variant: "outlined",
                                                    helperText: isStillFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typewriter/* default */.Z, {
                                                        input: "Your question is: ".concat(tagsInputText, ". While waiting for the perfect response. I would like to introduce you some facts about me. Whether you're looking for a quick answer to a question or need some guidance with a project, I'm always here to lend a helping hand. And the best part? You don't have to worry about any awkward small talk or judgement, because I'm here to listen and provide you with the best possible response. So go ahead, ask me anything! I'm always ready and willing to chat. And if you ever have any feedback or suggestions for how I can improve, I'm all ears. After all, my main goal is to make your life easier and more enjoyable.Thank you for choosing us as your trusted AI assistant. Let's chat!")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                                                    size: "large",
                                                    variant: "contained",
                                                    sx: {
                                                        minWidth: "10rem"
                                                    },
                                                    loading: visitorGeneratePromptWithTagsQueryLoading || visitorGeneratePromptLazyQueryLoading,
                                                    onClick: function() {
                                                        setTagsOutputText("");
                                                        setInputTextDesc("");
                                                        setDefaultInput("");
                                                        visitorGeneratePromptLazyQueryLazy({
                                                            variables: {
                                                                promptId: "marketing_questions",
                                                                language: (0,utils/* systemLocaleTransformer */.fW)(router.locale),
                                                                prompt: tagsInputText
                                                            },
                                                            context: {
                                                                headers: (0,_define_property/* default */.Z)({}, constants/* SHARED_PROMPT_HEADER_FOR_HERO_SECTION */.c, sys.id)
                                                            }
                                                        }).then(function() {
                                                            var ref;
                                                            visitorGeneratePromptWithTags({
                                                                context: {
                                                                    headers: (0,_define_property/* default */.Z)({}, constants/* SHARED_PROMPT_HEADER_FOR_HERO_SECTION */.c, sys.id)
                                                                },
                                                                variables: {
                                                                    promptId: "recommendation_tags_chat",
                                                                    language: (0,utils/* systemLocaleTransformer */.fW)(router.locale),
                                                                    prompt: tagsInputText,
                                                                    tags: (ref = tags.map(function(item) {
                                                                        return item === null || item === void 0 ? void 0 : item.name;
                                                                    }).filter(common/* notEmpty */.D)) !== null && ref !== void 0 ? ref : []
                                                                }
                                                            });
                                                        });
                                                    },
                                                    children: "Try It!"
                                                })
                                            ]
                                        }),
                                        defaultInput && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typewriter/* default */.Z, {
                                            input: defaultInput
                                        }),
                                        inputTextDesc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typewriter/* default */.Z, {
                                            input: inputTextDesc
                                        }),
                                        tagsOutputText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typewriter/* default */.Z, {
                                            input: renderTagText,
                                            renderText: function(text) {
                                                var isFinished = (renderTagText === null || renderTagText === void 0 ? void 0 : renderTagText.length) === text.length;
                                                var tags = (text.match(new RegExp(allProductSearchTags.map(function(searchTag) {
                                                    return searchTag.name;
                                                }).join("|"), "g")) || []).filter(function(tag) {
                                                    return allProductSearchTags.find(function(searchTag) {
                                                        return searchTag.name === tag;
                                                    });
                                                }).map(function(tag) {
                                                    return allProductSearchTags.find(function(searchTag) {
                                                        return searchTag.name === tag;
                                                    });
                                                });
                                                if (isFinished && tags.length === 0) {
                                                    tags = sampleSize_default()(allProductSearchTags, 3);
                                                }
                                                var tagsQueryString = tags.map(function(tag) {
                                                    return "".concat(tag.id, "_").concat(tag.name);
                                                }).join("|");
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                text,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: isFinished && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "".concat(paths/* PATH_PAGE.products */.ko.products, "?tags=").concat(tagsQueryString),
                                                                        prefetch: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                            sx: {
                                                                                m: 0.5,
                                                                                textDecoration: "underline"
                                                                            },
                                                                            noWrap: true,
                                                                            href: "".concat(paths/* PATH_PAGE.products */.ko.products, "?tags=").concat(tagsQueryString),
                                                                            children: "visit the smart recommendation page"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        tags.map(function(tag, tagIndex) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: tag ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "".concat(paths/* PATH_PAGE.products */.ko.products, "?tags=").concat(tag.id, "_").concat(tag.name),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                                                        label: tag.name,
                                                                        sx: {
                                                                            m: 0.5
                                                                        }
                                                                    }, tag.id + tagIndex)
                                                                }, tag.id + tagIndex) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                            });
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    height: {
                        md: "100vh"
                    }
                }
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./src/sections/landing/Shares.tsx
var Shares = __webpack_require__(29608);
// EXTERNAL MODULE: ./src/theme/palette.ts
var palette = __webpack_require__(78187);
;// CONCATENATED MODULE: ./src/sections/landing/LandingService.tsx










function LandingService(props) {
    var ref;
    var contentfulDataFragment = props.contentfulDataFragment, backgroundColor = props.backgroundColor;
    var theme = (0,useTheme/* default */.Z)();
    var ref1, ref2, ref3, ref4, ref5;
    var services = (ref5 = (ref = contentfulDataFragment.componentsCollection) === null || ref === void 0 ? void 0 : ref.items.map(function(item) {
        var ref;
        return {
            title: (ref1 = item === null || item === void 0 ? void 0 : item.title) !== null && ref1 !== void 0 ? ref1 : null,
            services: (ref2 = item === null || item === void 0 ? void 0 : (ref = item.services) === null || ref === void 0 ? void 0 : ref.filter(common/* notEmpty */.D)) !== null && ref2 !== void 0 ? ref2 : [],
            callToActionText: (ref3 = item === null || item === void 0 ? void 0 : item.callToActionText) !== null && ref3 !== void 0 ? ref3 : null,
            callToActionHref: (ref4 = item === null || item === void 0 ? void 0 : item.callToActionHref) !== null && ref4 !== void 0 ? ref4 : null
        };
    })) !== null && ref5 !== void 0 ? ref5 : [];
    var _title, _description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                    title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : "",
                    subtitleFontSize: "0.9rem"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 5,
                    children: services === null || services === void 0 ? void 0 : services.map(function(service) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                variants: service.title === "Standard Plus" ? (0,animate/* varFade */.EU)().inDown : (0,animate/* varFade */.EU)().inUp,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceCard, {
                                    service: service
                                })
                            })
                        }, service.title);
                    })
                })
            ]
        })
    });
}
function ServiceCard(param) {
    var service = param.service;
    var title = service.title, services = service.services, callToActionHref = service.callToActionHref, callToActionText = service.callToActionText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        sx: {
            p: 5,
            boxShadow: 0
        },
        style: {
            border: "1px solid ".concat(palette/* default.light.grey.600 */.ZP.light.grey[600])
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            spacing: 5,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    spacing: 2.5,
                    children: services.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            spacing: 1.5,
                            direction: "row",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                    icon: "eva:checkmark-fill",
                                    sx: {
                                        color: "primary.main",
                                        width: 30,
                                        height: 30,
                                        flexShrink: 0
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body1",
                                    children: item
                                })
                            ]
                        }, item);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    spacing: 1.5,
                    direction: "row",
                    alignItems: "center",
                    children: !!callToActionText && !!callToActionHref ? callToActionHref.startsWith("#") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                        to: callToActionHref,
                        spy: true,
                        smooth: true,
                        offset: -80,
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            size: "large",
                            fullWidth: true,
                            variant: "outlined",
                            children: callToActionText
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        size: "large",
                        fullWidth: true,
                        target: callToActionHref.includes("http") ? "_blank" : undefined,
                        rel: callToActionHref.includes("http") ? "noopener" : undefined,
                        variant: "outlined",
                        disabled: !Boolean(callToActionHref.trim()),
                        href: callToActionHref,
                        children: callToActionText
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/lab/Timeline/Timeline.js + 1 modules
var Timeline = __webpack_require__(36599);
// EXTERNAL MODULE: ./node_modules/@mui/lab/TimelineItem/TimelineItem.js + 1 modules
var TimelineItem = __webpack_require__(36270);
// EXTERNAL MODULE: ./node_modules/@mui/lab/TimelineOppositeContent/TimelineOppositeContent.js
var TimelineOppositeContent = __webpack_require__(54123);
// EXTERNAL MODULE: ./node_modules/@mui/lab/TimelineSeparator/TimelineSeparator.js + 1 modules
var TimelineSeparator = __webpack_require__(9601);
// EXTERNAL MODULE: ./node_modules/@mui/lab/TimelineDot/TimelineDot.js + 1 modules
var TimelineDot = __webpack_require__(17494);
// EXTERNAL MODULE: ./node_modules/@mui/lab/TimelineConnector/TimelineConnector.js + 1 modules
var TimelineConnector = __webpack_require__(51221);
// EXTERNAL MODULE: ./node_modules/@mui/lab/TimelineContent/TimelineContent.js
var TimelineContent = __webpack_require__(72162);
// EXTERNAL MODULE: ./src/hooks/useResponsive.ts
var useResponsive = __webpack_require__(10653);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(29430);
// EXTERNAL MODULE: ./src/components/Image.tsx
var Image = __webpack_require__(97349);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/sections/landing/LandingExperienceTimeline.tsx

function LandingExperienceTimeline_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 500px;\n  height: 280px;\n\n  @media (max-width: 1120px) {\n    width: 100%;\n  }\n  @media (max-width: 1120px) and (min-width: 768px) {\n    height: 200px;\n  }\n  @media (max-width: 768px) and (min-width: 576px) {\n    height: 170px;\n  }\n  @media (max-width: 576px) {\n    height: 120px;\n  }\n"
    ]);
    LandingExperienceTimeline_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &:before {\n        content: none !important;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










function LandingExperienceTimeline(props) {
    var ref;
    var contentfulDataFragment = props.contentfulDataFragment, backgroundColor = props.backgroundColor;
    var theme = (0,useTheme/* default */.Z)();
    var ref1, ref2, ref3, ref4, ref5;
    var experiences = (ref5 = (ref = contentfulDataFragment.componentsCollection) === null || ref === void 0 ? void 0 : ref.items.map(function(item) {
        var ref;
        return {
            title: (ref1 = item === null || item === void 0 ? void 0 : item.title) !== null && ref1 !== void 0 ? ref1 : null,
            description: (ref2 = item === null || item === void 0 ? void 0 : item.description) !== null && ref2 !== void 0 ? ref2 : null,
            time: (ref3 = item === null || item === void 0 ? void 0 : item.displayTime) !== null && ref3 !== void 0 ? ref3 : null,
            image: (ref4 = item === null || item === void 0 ? void 0 : (ref = item.featureImage) === null || ref === void 0 ? void 0 : ref.url) !== null && ref4 !== void 0 ? ref4 : null
        };
    })) !== null && ref5 !== void 0 ? ref5 : [];
    var componentDateFormat = contentfulDataFragment.componentDateFormat;
    var _title, _description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                component: animate/* MotionViewport */.DG,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                    title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                sx: {
                    pb: 5,
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        position: "relative"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperienceTimeline, {
                        componentDateFormat: componentDateFormat !== null && componentDateFormat !== void 0 ? componentDateFormat : undefined,
                        experiences: experiences || []
                    })
                })
            })
        ]
    });
}
function ExperienceTimeline(param) {
    var experiences = param.experiences, componentDateFormat = param.componentDateFormat;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "md");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline/* default */.Z, {
        position: isDesktop ? "alternate" : "right",
        children: experiences.map(function(experience, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderItem, {
                experience: experience,
                isLast: index === experiences.length - 1,
                componentDateFormat: componentDateFormat
            }, experience.title);
        })
    });
}
// ----------------------------------------------------------------------
var StyledIframe = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    componentId: "sc-f8b6c82c-0"
})(LandingExperienceTimeline_templateObject());
var StyledTimelineItem = (0,styled_components_browser_esm/* default */.ZP)(TimelineItem/* default */.Z).withConfig({
    componentId: "sc-f8b6c82c-1"
})(_templateObject2(), function(props) {
    return !props.isDesktop && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
function OrderItem(param) {
    var experience = param.experience, isLast = param.isLast, componentDateFormat = param.componentDateFormat;
    var title = experience.title, description = experience.description, time = experience.time, image = experience.image, video = experience.video;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "md");
    var mediaComponent = video ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIframe, {
        src: video,
        title: title !== null && title !== void 0 ? title : undefined,
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true,
        style: {
            marginBottom: 1
        }
    }) : image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        alt: title !== null && title !== void 0 ? title : undefined,
        src: image,
        sx: {
            marginBottom: 1
        }
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var renderComponent = function() {
        if (time) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    time && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            color: "text.secondary",
                            marginBottom: 0.5
                        },
                        children: moment_default()(time).format(componentDateFormat !== null && componentDateFormat !== void 0 ? componentDateFormat : "YYYY-MM-DD")
                    }),
                    !isDesktop && mediaComponent,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h4",
                        mb: 2,
                        children: title
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    mb: 2,
                    variant: "body1",
                    children: title
                }),
                !isDesktop && mediaComponent
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTimelineItem, {
        isDesktop: isDesktop,
        children: [
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineOppositeContent/* default */.Z, {
                color: "text.secondary",
                children: mediaComponent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineSeparator/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineDot/* default */.Z, {
                        color: "primary"
                    }),
                    isLast && isDesktop ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineConnector/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimelineContent/* default */.Z, {
                children: [
                    renderComponent(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "div",
                        sx: {
                            color: "text.secondary"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* default */.Z, {
                            children: description || ""
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
// EXTERNAL MODULE: ./src/components/contentful/Shared.tsx
var Shared = __webpack_require__(41923);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
;// CONCATENATED MODULE: ./src/sections/landing/LandingVideo.tsx



function LandingVideo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: ",
        ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n\n  @media (max-width: 768px) {\n    height: 100%;\n  }\n\n  & > div {\n    border-radius: 16px;\n    overflow: hidden;\n  }\n  & > div > video {\n    display: block;\n    object-fit: contain;\n  }\n"
    ]);
    LandingVideo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LandingVideo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    LandingVideo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aaa715e1-0"
})(LandingVideo_templateObject(), function(props) {
    return props.hasMinHeight ? "70vh" : "auto";
});
var StyledTextFullWidth = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aaa715e1-1"
})(LandingVideo_templateObject1());
var GridAreaLandingVideo;
(function(GridAreaLandingVideo) {
    GridAreaLandingVideo["video"] = "video";
    GridAreaLandingVideo["content"] = "content";
})(GridAreaLandingVideo || (GridAreaLandingVideo = {}));
var defaultVideoRatio = {
    desktop: {
        width: "100%",
        height: "70vh"
    },
    mobile: {
        width: "100%",
        height: "50vh"
    }
};
function LandingVideo(props) {
    var ref, ref1, ref2, ref3, ref4;
    var contentfulDataFragment = props.contentfulDataFragment, backgroundColor = props.backgroundColor;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "sm");
    var mode = contentfulDataFragment.mode, videoRatio = contentfulDataFragment.videoRatio, callToAction = contentfulDataFragment.callToAction;
    var theme = (0,useTheme/* default */.Z)();
    var content = (ref = contentfulDataFragment.featureDescription) === null || ref === void 0 ? void 0 : ref.json;
    var _youtubeEmbedLink;
    var videoUrl = (_youtubeEmbedLink = contentfulDataFragment.youtubeEmbedLink) !== null && _youtubeEmbedLink !== void 0 ? _youtubeEmbedLink : (ref1 = contentfulDataFragment.video) === null || ref1 === void 0 ? void 0 : ref1.url;
    var imageUrl = (ref2 = contentfulDataFragment.image) === null || ref2 === void 0 ? void 0 : ref2.url;
    var displayVideoRatio = videoRatio === "1/1" ? "1/1" : videoRatio === "3/4" ? "3/4" : videoRatio === "4/3" ? "4/3" : "auto";
    var displayMode = mode === "basic" ? "basic" : mode === "two sections" ? "two sections" : "basic";
    // TODO: handle video ratio logic
    var videoPropsMobile = displayVideoRatio === "auto" ? defaultVideoRatio.mobile : defaultVideoRatio.mobile;
    // TODO: handle video ratio logic
    var videoPropsDesktop = displayVideoRatio === "auto" ? defaultVideoRatio.desktop : defaultVideoRatio.desktop;
    var _title, _description, ref5, ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        style: {
            paddingRight: 0,
            paddingLeft: 0
        },
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                    title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : ""
                }),
                displayMode === "basic" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        content && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextFullWidth, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared/* RichTextStyleWrapper */.w, {
                                children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(content, (0,Shared/* renderOptionFunc */.Z)((ref3 = contentfulDataFragment.featureDescription) === null || ref3 === void 0 ? void 0 : ref3.links.assets))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                            hasMinHeight: Boolean(videoUrl && !content),
                            children: [
                                videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isDesktop ? videoPropsDesktop : videoPropsMobile), {
                                    url: videoUrl,
                                    controls: true
                                })),
                                imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    disabledEffect: true,
                                    visibleByDefault: true,
                                    alt: imageUrl,
                                    src: imageUrl
                                })
                            ]
                        })
                    ]
                }),
                displayMode === "two sections" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "grid",
                        gridTemplateColumns: isDesktop && displayMode === "two sections" ? "repeat(2, 1fr)" : "repeat(1, 1fr)",
                        gridTemplateAreas: displayMode === "two sections" ? isDesktop ? "'".concat(GridAreaLandingVideo.video, " ").concat(GridAreaLandingVideo.content, "'") : "\n          '".concat(GridAreaLandingVideo.video, "'\n          '").concat(GridAreaLandingVideo.content, "'\n          ") : "",
                        gap: isDesktop ? 10 : 5,
                        children: [
                            content && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                style: {
                                    gridArea: GridAreaLandingVideo.content
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextFullWidth, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared/* RichTextStyleWrapper */.w, {
                                            children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(content, (0,Shared/* renderOptionFunc */.Z)((ref4 = contentfulDataFragment.featureDescription) === null || ref4 === void 0 ? void 0 : ref4.links.assets))
                                        })
                                    }),
                                    callToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: (ref5 = callToAction === null || callToAction === void 0 ? void 0 : callToAction.link) !== null && ref5 !== void 0 ? ref5 : "",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            target: "_blank",
                                            href: (ref6 = callToAction === null || callToAction === void 0 ? void 0 : callToAction.link) !== null && ref6 !== void 0 ? ref6 : "",
                                            variant: "contained",
                                            fullWidth: true,
                                            size: "large",
                                            children: (ref7 = callToAction === null || callToAction === void 0 ? void 0 : callToAction.title) !== null && ref7 !== void 0 ? ref7 : ""
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                style: {
                                    gridArea: GridAreaLandingVideo.video
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                                    hasMinHeight: Boolean(videoUrl && !content),
                                    children: [
                                        videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isDesktop ? videoPropsDesktop : videoPropsMobile), {
                                            url: videoUrl,
                                            controls: true
                                        })),
                                        imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            disabledEffect: true,
                                            visibleByDefault: true,
                                            alt: imageUrl,
                                            src: imageUrl
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(94581);
// EXTERNAL MODULE: ./src/components/carousel/index.ts + 4 modules
var carousel = __webpack_require__(23770);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/styles.css
var styles = __webpack_require__(50781);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/captions/captions.css
var captions = __webpack_require__(41879);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css
var thumbnails = __webpack_require__(53402);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/index.js + 8 modules
var dist = __webpack_require__(71227);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/zoom/index.js + 6 modules
var zoom = __webpack_require__(94500);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/video/index.js + 2 modules
var video = __webpack_require__(81344);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/captions/index.js + 5 modules
var plugins_captions = __webpack_require__(44548);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/slideshow/index.js + 2 modules
var slideshow = __webpack_require__(48818);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/fullscreen/index.js + 3 modules
var fullscreen = __webpack_require__(69178);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/index.js + 5 modules
var plugins_thumbnails = __webpack_require__(52806);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/core/contexts/LightboxState.js
var LightboxState = __webpack_require__(12986);
// EXTERNAL MODULE: ./node_modules/@mui/material/GlobalStyles/GlobalStyles.js + 1 modules
var GlobalStyles = __webpack_require__(42287);
;// CONCATENATED MODULE: ./src/components/lightbox/styles.tsx



function StyledLightbox() {
    var theme = (0,useTheme/* default */.Z)();
    var inputGlobalStyles = /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles/* default */.Z, {
        styles: {
            ".yarl__root": {
                "--yarl__thumbnails_thumbnail_padding": 0,
                "--yarl__thumbnails_thumbnail_border": "transparent",
                "--yarl__color_backdrop": (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[900], 0.9),
                "--yarl__slide_captions_container_background": (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[900], 0.48)
            },
            // Caption
            ".yarl__slide_title": {
                fontSize: theme.typography.h5.fontSize,
                fontWeight: theme.typography.h5.fontWeight,
                lineHeight: theme.typography.h5.lineHeight
            },
            ".yarl__slide_description": {
                fontSize: theme.typography.body2.fontSize,
                fontWeight: theme.typography.body2.fontWeight,
                lineHeight: theme.typography.body2.lineHeight
            },
            // Button
            ".yarl__button": {
                filter: "unset"
            },
            // Thumbnails
            ".yarl__thumbnails_thumbnail": {
                opacity: 0.48,
                "&.yarl__thumbnails_thumbnail_active": {
                    opacity: 1
                }
            },
            ".yarl__thumbnails_vignette": {
                "--yarl__thumbnails_vignette_size": 0
            },
            // Video
            ".yarl__video_container": {
                backgroundColor: theme.palette.common.black
            }
        }
    });
    return inputGlobalStyles;
}

;// CONCATENATED MODULE: ./src/components/lightbox/Lightbox.tsx














// ----------------------------------------------------------------------
var ICON_SIZE = 24;
function Lightbox(_param) {
    var slides = _param.slides, disabledZoom = _param.disabledZoom, disabledVideo = _param.disabledVideo, disabledTotal = _param.disabledTotal, disabledCaptions = _param.disabledCaptions, disabledSlideshow = _param.disabledSlideshow, disabledThumbnails = _param.disabledThumbnails, disabledFullscreen = _param.disabledFullscreen, onGetCurrentIndex = _param.onGetCurrentIndex, other = (0,_object_without_properties/* default */.Z)(_param, [
        "slides",
        "disabledZoom",
        "disabledVideo",
        "disabledTotal",
        "disabledCaptions",
        "disabledSlideshow",
        "disabledThumbnails",
        "disabledFullscreen",
        "onGetCurrentIndex"
    ]);
    var totalItems = slides ? slides.length : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLightbox, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, (0,_object_spread/* default */.Z)({
                slides: slides,
                animation: {
                    swipe: 240
                },
                carousel: {
                    finite: totalItems < 5
                },
                controller: {
                    closeOnBackdropClick: true
                },
                plugins: getPlugins({
                    disabledZoom: disabledZoom,
                    disabledVideo: disabledVideo,
                    disabledCaptions: disabledCaptions,
                    disabledSlideshow: disabledSlideshow,
                    disabledThumbnails: disabledThumbnails,
                    disabledFullscreen: disabledFullscreen
                }),
                on: {
                    view: function(index) {
                        if (onGetCurrentIndex) {
                            onGetCurrentIndex(index);
                        }
                    }
                },
                toolbar: {
                    buttons: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayTotal, {
                            totalItems: totalItems,
                            disabledTotal: disabledTotal,
                            disabledCaptions: disabledCaptions
                        }, 0),
                        "close", 
                    ]
                },
                render: {
                    iconClose: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            width: ICON_SIZE,
                            icon: "carbon:close"
                        });
                    },
                    iconZoomIn: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            width: ICON_SIZE,
                            icon: "carbon:zoom-in"
                        });
                    },
                    iconZoomOut: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            width: ICON_SIZE,
                            icon: "carbon:zoom-out"
                        });
                    },
                    iconSlideshowPlay: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            width: ICON_SIZE,
                            icon: "carbon:play"
                        });
                    },
                    iconSlideshowPause: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            width: ICON_SIZE,
                            icon: "carbon:pause"
                        });
                    },
                    iconPrev: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            width: ICON_SIZE + 8,
                            icon: "carbon:chevron-left"
                        });
                    },
                    iconNext: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            width: ICON_SIZE + 8,
                            icon: "carbon:chevron-right"
                        });
                    },
                    iconExitFullscreen: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            width: ICON_SIZE,
                            icon: "carbon:center-to-fit"
                        });
                    },
                    iconEnterFullscreen: function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            width: ICON_SIZE,
                            icon: "carbon:fit-to-screen"
                        });
                    }
                }
            }, other))
        ]
    });
}
// ----------------------------------------------------------------------
function getPlugins(param) {
    var disabledZoom = param.disabledZoom, disabledVideo = param.disabledVideo, disabledCaptions = param.disabledCaptions, disabledSlideshow = param.disabledSlideshow, disabledThumbnails = param.disabledThumbnails, disabledFullscreen = param.disabledFullscreen;
    var plugins = [
        plugins_captions/* default */.Z,
        fullscreen/* default */.Z,
        slideshow/* default */.Z,
        plugins_thumbnails/* default */.Z,
        video/* default */.Z,
        zoom/* default */.ZP
    ];
    if (disabledThumbnails) {
        plugins = plugins.filter(function(plugin) {
            return plugin !== plugins_thumbnails/* default */.Z;
        });
    }
    if (disabledCaptions) {
        plugins = plugins.filter(function(plugin) {
            return plugin !== plugins_captions/* default */.Z;
        });
    }
    if (disabledFullscreen) {
        plugins = plugins.filter(function(plugin) {
            return plugin !== fullscreen/* default */.Z;
        });
    }
    if (disabledSlideshow) {
        plugins = plugins.filter(function(plugin) {
            return plugin !== slideshow/* default */.Z;
        });
    }
    if (disabledZoom) {
        plugins = plugins.filter(function(plugin) {
            return plugin !== zoom/* default */.ZP;
        });
    }
    if (disabledVideo) {
        plugins = plugins.filter(function(plugin) {
            return plugin !== video/* default */.Z;
        });
    }
    return plugins;
}
function DisplayTotal(param) {
    var totalItems = param.totalItems, disabledTotal = param.disabledTotal, disabledCaptions = param.disabledCaptions;
    var state = (0,LightboxState/* useLightboxState */.o)().state;
    var currentIndex = state.currentIndex;
    if (disabledTotal) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
        className: "yarl__button",
        sx: (0,_object_spread/* default */.Z)({
            pl: 3,
            left: 0,
            position: "fixed",
            typography: "body2"
        }, !disabledCaptions && {
            px: "unset",
            minWidth: 64,
            position: "unset",
            textAlign: "center"
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                children: [
                    " ",
                    currentIndex + 1,
                    " "
                ]
            }),
            " / ",
            totalItems
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/lightbox/index.ts







// EXTERNAL MODULE: ./src/utils/cssStyles.ts
var cssStyles = __webpack_require__(20727);
;// CONCATENATED MODULE: ./src/sections/landing/LandingImageList.tsx

















var THUMB_SIZE = 64;
var StyledThumbnailsContainer = (0,styled/* default */.ZP)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "length";
    }
})(function(param) {
    var length = param.length, theme = param.theme;
    return (0,_object_spread/* default */.Z)({
        margin: theme.spacing(0, "auto"),
        position: "relative",
        "& .slick-slide": {
            opacity: 0.48,
            "&.slick-current": {
                opacity: 1
            },
            "& > div": {
                padding: theme.spacing(0, 0.75)
            }
        }
    }, length === 1 && {
        maxWidth: THUMB_SIZE * 1 + 16
    }, length === 2 && {
        maxWidth: THUMB_SIZE * 2 + 32
    }, (length === 3 || length === 4) && {
        maxWidth: THUMB_SIZE * 3 + 48
    }, length >= 5 && {
        maxWidth: THUMB_SIZE * 6
    }, length > 2 && {
        "&:before, &:after": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)(theme).bgGradient({
            direction: "to left",
            startColor: "".concat((0,colorManipulator/* alpha */.Fq)(theme.palette.background.default, 0), " 0%"),
            endColor: "".concat(theme.palette.background.default, " 100%")
        })), {
            top: 0,
            zIndex: 9,
            content: "''",
            height: "100%",
            position: "absolute",
            width: THUMB_SIZE * 2 / 3
        }),
        "&:after": {
            right: 0,
            transform: "scaleX(-1)"
        }
    });
});
var CarouselThumbnail = function(props) {
    var theme = (0,useTheme/* default */.Z)();
    var imageUrls = props.imageUrls;
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var ref1 = (0,react.useState)(undefined), nav1 = ref1[0], setNav1 = ref1[1];
    var ref2 = (0,react.useState)(undefined), nav2 = ref2[0], setNav2 = ref2[1];
    var carousel2 = (0,react.useRef)(null);
    var slider2 = (0,react.useRef)(null);
    var carousel1 = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(-1), selectedImage = ref3[0], setSelectedImage = ref3[1];
    var carouselSettings1 = {
        dots: false,
        arrows: false,
        slidesToShow: 1,
        draggable: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        beforeChange: function(current, next) {
            return setCurrentIndex(next);
        }
    };
    (0,react.useEffect)(function() {
        if (carousel1.current) {
            setNav1(carousel1.current);
        }
        if (carousel2.current) {
            setNav2(carousel2.current);
        }
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        (ref = carousel1.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(currentIndex);
    }, [
        currentIndex
    ]);
    var handlePrevious = function() {
        var ref;
        (ref = slider2.current) === null || ref === void 0 ? void 0 : ref.slickPrev();
    };
    var handleNext = function() {
        var ref;
        (ref = slider2.current) === null || ref === void 0 ? void 0 : ref.slickNext();
    };
    var handleOpenLightbox = function(imageUrl) {
        var imageIndex = imageUrls.findIndex(function(url) {
            return url === imageUrl;
        });
        setSelectedImage(imageIndex);
    };
    var handleCloseLightbox = function() {
        setSelectedImage(-1);
    };
    var ref4;
    var imagesLightbox = (ref4 = imageUrls.map(function(imageUrl) {
        return {
            src: imageUrl
        };
    })) !== null && ref4 !== void 0 ? ref4 : [];
    (0,react.useEffect)(function() {
        if (carousel1.current) {
            setNav1(carousel1.current);
        }
        if (carousel2.current) {
            setNav2(carousel2.current);
        }
    }, []);
    var carouselSettings2 = {
        dots: false,
        arrows: false,
        centerMode: true,
        swipeToSlide: true,
        focusOnSelect: true,
        variableWidth: true,
        centerPadding: "0px",
        slidesToShow: imageUrls.length > 3 ? 3 : imageUrls.length
    };
    var renderThumbnails = /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledThumbnailsContainer, {
        length: imageUrls.length,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carouselSettings2), {
            asNavFor: nav1,
            ref: carousel2,
            children: imageUrls.map(function(img, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    disabledEffect: true,
                    alt: "thumbnail",
                    src: img,
                    sx: (0,_object_spread/* default */.Z)({
                        width: THUMB_SIZE,
                        height: THUMB_SIZE,
                        borderRadius: 1.5,
                        cursor: "pointer"
                    }, currentIndex === index && {
                        border: "solid 2px ".concat(theme.palette.primary.main)
                    })
                }, img);
            })
        }))
    });
    var renderLargeImg = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            mb: 3,
            borderRadius: 2,
            overflow: "hidden",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carouselSettings1), {
                asNavFor: nav2,
                ref: carousel1,
                children: imageUrls.map(function(img) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        alt: "product",
                        src: img,
                        ratio: "1/1",
                        onClick: function() {
                            return handleOpenLightbox(img);
                        },
                        sx: {
                            cursor: "zoom-in"
                        }
                    }, img);
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* CarouselArrowIndex */.cU, {
                index: currentIndex,
                total: imageUrls.length,
                onNext: handleNext,
                onPrevious: handlePrevious
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    "& .slick-slide": {
                        float: theme.direction === "rtl" ? "right" : "left"
                    }
                },
                children: [
                    renderLargeImg,
                    renderThumbnails
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Lightbox, {
                index: selectedImage,
                slides: imagesLightbox,
                open: selectedImage >= 0,
                close: handleCloseLightbox,
                onGetCurrentIndex: function(index) {
                    return setCurrentIndex(index);
                }
            })
        ]
    });
};
function LandingImageList(props) {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var contentfulDataFragment = props.contentfulDataFragment, backgroundColor = props.backgroundColor;
    var isDesktop = (0,useResponsive/* default */.Z)("up", "sm");
    var gridModeColumnsCountMobile = contentfulDataFragment.gridModeColumnsCountMobile, gridModeColumnsCountDesktop = contentfulDataFragment.gridModeColumnsCountDesktop, displayMode = contentfulDataFragment.displayMode, gridModeGapDesktop = contentfulDataFragment.gridModeGapDesktop, gridModeGapMobile = contentfulDataFragment.gridModeGapMobile, imagesWithHrefDesktopCollection = contentfulDataFragment.imagesWithHrefDesktopCollection, imagesWithHrefMobileCollection = contentfulDataFragment.imagesWithHrefMobileCollection;
    var mode = displayMode === "slider" ? "slider" : displayMode === "grid" ? "grid" : "grid";
    var theme = (0,useTheme/* default */.Z)();
    var ref2, ref3;
    var mobileImages = (0,_to_consumable_array/* default */.Z)((ref2 = (ref = contentfulDataFragment.imagesMobileCollection) === null || ref === void 0 ? void 0 : ref.items) !== null && ref2 !== void 0 ? ref2 : []).concat((0,_to_consumable_array/* default */.Z)((ref3 = imagesWithHrefMobileCollection === null || imagesWithHrefMobileCollection === void 0 ? void 0 : imagesWithHrefMobileCollection.items) !== null && ref3 !== void 0 ? ref3 : []));
    var ref4, ref5;
    var desktopImages = (0,_to_consumable_array/* default */.Z)((ref4 = (ref1 = contentfulDataFragment.imagesCollection) === null || ref1 === void 0 ? void 0 : ref1.items) !== null && ref4 !== void 0 ? ref4 : []).concat((0,_to_consumable_array/* default */.Z)((ref5 = imagesWithHrefDesktopCollection === null || imagesWithHrefDesktopCollection === void 0 ? void 0 : imagesWithHrefDesktopCollection.items) !== null && ref5 !== void 0 ? ref5 : []));
    var displayImages = (isDesktop ? desktopImages : mobileImages.length !== 0 ? mobileImages !== null && mobileImages !== void 0 ? mobileImages : [] : desktopImages !== null && desktopImages !== void 0 ? desktopImages : []).map(function(image) {
        var ref;
        // this is a workaround that server side code does not know about the __typename
        var anyImage = image;
        if (anyImage === null || anyImage === void 0 ? void 0 : (ref = anyImage.image) === null || ref === void 0 ? void 0 : ref.url) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, image), {
                __typename: "SectionsImage"
            });
        }
        if (anyImage === null || anyImage === void 0 ? void 0 : anyImage.url) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, image), {
                __typename: "Asset"
            });
        }
        return image;
    });
    var ref6;
    var imageUrls = (ref6 = displayImages.map(function(item) {
        if ((item === null || item === void 0 ? void 0 : item.__typename) === "SectionsImage") {
            var ref;
            return (ref = item.image) === null || ref === void 0 ? void 0 : ref.url;
        }
        if ((item === null || item === void 0 ? void 0 : item.__typename) === "Asset") {
            return item.url;
        }
        return "";
    }).filter(common/* notEmpty */.D)) !== null && ref6 !== void 0 ? ref6 : [];
    var _title, _description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                    title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : ""
                }),
                mode === "slider" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselThumbnail, {
                    imageUrls: imageUrls
                }),
                mode === "grid" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: "grid",
                        gridTemplateColumns: isDesktop ? "repeat(".concat(gridModeColumnsCountDesktop !== null && gridModeColumnsCountDesktop !== void 0 ? gridModeColumnsCountDesktop : 1, ", 1fr)") : "repeat(".concat(gridModeColumnsCountMobile !== null && gridModeColumnsCountMobile !== void 0 ? gridModeColumnsCountMobile : 1, ", 1fr)"),
                        gap: isDesktop ? gridModeGapDesktop !== null && gridModeGapDesktop !== void 0 ? gridModeGapDesktop : 10 : gridModeGapMobile !== null && gridModeGapMobile !== void 0 ? gridModeGapMobile : 5,
                        children: displayImages === null || displayImages === void 0 ? void 0 : displayImages.map(function(image, urlIndex) {
                            var url = "-";
                            var href = undefined;
                            if ((image === null || image === void 0 ? void 0 : image.__typename) === "Asset") {
                                var ref;
                                url = (ref = image === null || image === void 0 ? void 0 : image.url) !== null && ref !== void 0 ? ref : "-";
                            }
                            if ((image === null || image === void 0 ? void 0 : image.__typename) === "SectionsImage") {
                                var ref1;
                                var ref2;
                                url = (ref2 = image === null || image === void 0 ? void 0 : (ref1 = image.image) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref2 !== void 0 ? ref2 : "-";
                                var _callToActionHref;
                                href = (_callToActionHref = image.callToActionHref) !== null && _callToActionHref !== void 0 ? _callToActionHref : undefined;
                            }
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: href,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: href,
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            alt: url,
                                            src: url
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    alt: url,
                                    src: url
                                })
                            }, url + urlIndex);
                        })
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/landing/LandingHumanList.tsx






function LandingPartner(props) {
    var ref;
    var backgroundColor = props.backgroundColor, contentfulDataFragment = props.contentfulDataFragment;
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("lg"));
    var ref1, ref2, ref3, ref4, ref5;
    var humanList = (ref5 = (ref = contentfulDataFragment.componentsCollection) === null || ref === void 0 ? void 0 : ref.items.map(function(item) {
        var ref;
        return {
            name: (ref1 = item === null || item === void 0 ? void 0 : item.title) !== null && ref1 !== void 0 ? ref1 : null,
            avatar: (ref2 = item === null || item === void 0 ? void 0 : (ref = item.featureImage) === null || ref === void 0 ? void 0 : ref.url) !== null && ref2 !== void 0 ? ref2 : null,
            link: {
                title: (ref3 = item === null || item === void 0 ? void 0 : item.description) !== null && ref3 !== void 0 ? ref3 : null,
                href: (ref4 = item === null || item === void 0 ? void 0 : item.descriptionHref) !== null && ref4 !== void 0 ? ref4 : null
            }
        };
    })) !== null && ref5 !== void 0 ? ref5 : [];
    var _title, _description, _name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            sx: {
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                    title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: isMobile ? 2 : 5,
                    justifyContent: "center",
                    alignItems: "center",
                    children: humanList.map(function(human, humanIndex) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                component: motion_minimal.m.div,
                                variants: (0,animate/* varFade */.EU)().in,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HumanCard, {
                                    human: human
                                })
                            })
                        }, ((_name = human.name) !== null && _name !== void 0 ? _name : "") + humanIndex);
                    })
                })
            ]
        })
    });
}
function HumanCard(param) {
    var human = param.human;
    var ref;
    var name = human.name, avatar = human.avatar, link = human.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        sx: {
            p: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "subtitle1",
                sx: {
                    mt: 2,
                    mb: 0.5
                },
                children: name
            }),
            (link === null || link === void 0 ? void 0 : (ref = link.href) === null || ref === void 0 ? void 0 : ref.trim()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: link.href.trim(),
                target: "_blank",
                rel: "noopener",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        mb: 2,
                        textDecoration: "underline"
                    },
                    children: link === null || link === void 0 ? void 0 : link.title
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    mb: 2
                },
                children: link === null || link === void 0 ? void 0 : link.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                style: {
                    borderRadius: "16px",
                    objectPosition: "top"
                },
                alt: name !== null && name !== void 0 ? name : undefined,
                src: avatar !== null && avatar !== void 0 ? avatar : undefined,
                ratio: "1/1"
            })
        ]
    }, name);
}

;// CONCATENATED MODULE: ./src/sections/landing/LandingDetailPersonList.tsx









function LandingDetailPerson(props) {
    var ref;
    var contentfulDataFragment = props.contentfulDataFragment, backgroundColor = props.backgroundColor;
    var theme = (0,useTheme/* default */.Z)();
    var ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var personList = (ref7 = (ref = contentfulDataFragment.componentsCollection) === null || ref === void 0 ? void 0 : ref.items.map(function(item) {
        var ref, ref7;
        return {
            name: (ref1 = item === null || item === void 0 ? void 0 : item.title) !== null && ref1 !== void 0 ? ref1 : null,
            avatar: (ref2 = item === null || item === void 0 ? void 0 : (ref = item.avatar) === null || ref === void 0 ? void 0 : ref.url) !== null && ref2 !== void 0 ? ref2 : null,
            nameHref: (ref3 = item === null || item === void 0 ? void 0 : item.titleHref) !== null && ref3 !== void 0 ? ref3 : null,
            description: (ref4 = item === null || item === void 0 ? void 0 : item.description) !== null && ref4 !== void 0 ? ref4 : null,
            descriptionHref: (ref5 = item === null || item === void 0 ? void 0 : item.descriptionHref) !== null && ref5 !== void 0 ? ref5 : null,
            detail: (ref6 = item === null || item === void 0 ? void 0 : (ref7 = item.detail) === null || ref7 === void 0 ? void 0 : ref7.json) !== null && ref6 !== void 0 ? ref6 : null
        };
    })) !== null && ref7 !== void 0 ? ref7 : [];
    var _title, _description, _name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            sx: {
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                    title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 5,
                    justifyContent: "center",
                    children: personList === null || personList === void 0 ? void 0 : personList.map(function(person, personIndex) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                variants: (0,animate/* varFade */.EU)().in,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonCard, {
                                    person: person
                                })
                            })
                        }, ((_name = person.name) !== null && _name !== void 0 ? _name : "") + personIndex);
                    })
                })
            ]
        })
    });
}
function PersonCard(param) {
    var person = param.person;
    var theme = (0,useTheme/* default */.Z)();
    var name = person.name, nameHref = person.nameHref, avatar = person.avatar, description = person.description, descriptionHref = person.descriptionHref, detail = person.detail;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        sx: {
            p: 2.5
        },
        children: [
            (nameHref === null || nameHref === void 0 ? void 0 : nameHref.trim()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: nameHref.trim(),
                target: "_blank",
                rel: "noopener",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    textAlign: "center",
                    variant: "subtitle1",
                    sx: {
                        mt: 2,
                        mb: 0.5
                    },
                    children: name
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                textAlign: "center",
                variant: "subtitle1",
                sx: {
                    mt: 2,
                    mb: 0.5
                },
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                textAlign: "center",
                sx: {
                    mb: 1
                },
                children: (descriptionHref === null || descriptionHref === void 0 ? void 0 : descriptionHref.trim()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: descriptionHref.trim(),
                    target: "_blank",
                    rel: "noopener",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        sx: {
                            textDecoration: "underline"
                        },
                        children: description
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "caption",
                    children: description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                style: {
                    borderRadius: "5px",
                    border: "0.5px solid ".concat(theme.palette.grey[400]),
                    objectPosition: "top"
                },
                alt: name !== null && name !== void 0 ? name : undefined,
                src: avatar !== null && avatar !== void 0 ? avatar : undefined,
                ratio: "1/1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                textAlign: "initial",
                sx: {
                    mt: 1
                },
                children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(detail, {
                    renderText: function(text) {
                        return text.split("\n").reduce(function(children, textSegment, index) {
                            return (0,_to_consumable_array/* default */.Z)(children).concat([
                                index > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                    style: {
                                        display: "block",
                                        margin: "15px 0",
                                        content: "''"
                                    }
                                }, index),
                                textSegment, 
                            ]);
                        }, []);
                    }
                })
            })
        ]
    }, name);
}

// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(67358);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
;// CONCATENATED MODULE: ./src/sections/landing/LandingFaqList.tsx










function LandingFaqList(props) {
    var ref;
    var contentfulDataFragment = props.contentfulDataFragment, backgroundColor = props.backgroundColor;
    var theme = (0,useTheme/* default */.Z)();
    var ref1 = (0,react.useState)(false), controlled = ref1[0], setControlled = ref1[1];
    var handleChangeControlled = function(panel, isExpanded) {
        setControlled(isExpanded ? panel : false);
    };
    var ref2, ref3;
    var faqList = (ref3 = (ref = contentfulDataFragment.componentsCollection) === null || ref === void 0 ? void 0 : ref.items.map(function(item) {
        var ref;
        return {
            title: (ref2 = item === null || item === void 0 ? void 0 : item.title) !== null && ref2 !== void 0 ? ref2 : null,
            content: item === null || item === void 0 ? void 0 : (ref = item.content) === null || ref === void 0 ? void 0 : ref.json
        };
    })) !== null && ref3 !== void 0 ? ref3 : [];
    var _title, _description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                    title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 5,
                    children: faqList === null || faqList === void 0 ? void 0 : faqList.map(function(faq, faqIndex) {
                        var ref;
                        var key = ((ref = faq === null || faq === void 0 ? void 0 : faq.title) !== null && ref !== void 0 ? ref : "") + faqIndex;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            width: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                variants: (0,animate/* varFade */.EU)().inUp,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                    expanded: controlled === key,
                                    onChange: function(_event, isExpanded) {
                                        return faq.title && handleChangeControlled(key, isExpanded);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                            expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                                icon: "eva:arrow-ios-downward-fill",
                                                width: 20,
                                                height: 20
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "subtitle1",
                                                children: faq.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared/* RichTextStyleWrapper */.w, {
                                                children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(faq.content, (0,Shared/* renderOptionFunc */.Z)())
                                            })
                                        })
                                    ]
                                })
                            })
                        }, key);
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/landing/LandingContact.tsx








var LandingContact_ContentStyle = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        maxWidth: 456,
        margin: "auto",
        overflow: "hidden",
        paddingBottom: theme.spacing(15),
        marginTop: theme.spacing(15),
        marginBottom: theme.spacing(15),
        backgroundColor: theme.palette.background.neutral,
        borderRadius: Number(theme.shape.borderRadius) * 2,
        backgroundImage: "linear-gradient(135deg,\n    ".concat(theme.palette.primary.main, " 0%,\n    ").concat(theme.palette.primary.dark, " 100%)")
    }, theme.breakpoints.up("md"), {
        display: "flex",
        maxWidth: "100%",
        paddingBottom: 0,
        alignItems: "center"
    });
});
// ----------------------------------------------------------------------
var contactIcons = [
    {
        type: "email",
        icon: "eva:email-outline"
    },
    {
        type: "facebook",
        icon: "eva:facebook-outline"
    },
    {
        type: "instagram",
        icon: "ant-design:instagram-outlined"
    },
    {
        type: "discord",
        icon: "mingcute:discord-line"
    },
    {
        type: "twitter",
        icon: "eva:twitter-outline"
    },
    {
        type: "line",
        icon: "cib:line"
    }, 
];
function LandingContact(props) {
    var ref;
    var contentfulDataFragment = props.contentfulDataFragment;
    var ref1, ref2, ref3;
    var contacts = (ref3 = (ref = contentfulDataFragment.linksCollection) === null || ref === void 0 ? void 0 : ref.items.map(function(item) {
        return {
            link: (ref1 = item === null || item === void 0 ? void 0 : item.href) !== null && ref1 !== void 0 ? ref1 : null,
            text: (ref2 = item === null || item === void 0 ? void 0 : item.title) !== null && ref2 !== void 0 ? ref2 : null
        };
    })) !== null && ref3 !== void 0 ? ref3 : [];
    var _title, _link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        component: animate/* MotionViewport */.DG,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LandingContact_ContentStyle, {
            id: "contact",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    component: motion_minimal.m.div,
                    variants: (0,animate/* varFade */.EU)().inUp,
                    sx: {
                        mb: {
                            xs: 3,
                            md: 0
                        }
                    },
                    id: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                        animate: {
                            y: [
                                -20,
                                0,
                                -20
                            ]
                        },
                        transition: {
                            duration: 4,
                            repeat: Infinity
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            visibleByDefault: true,
                            alt: "rocket",
                            src: "/assets/images/rocket.png",
                            disabledEffect: true,
                            sx: {
                                maxWidth: 460
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        pl: {
                            md: 10
                        },
                        textAlign: {
                            xs: "center",
                            md: "left"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            component: motion_minimal.m.div,
                            variants: (0,animate/* varFade */.EU)().inDown,
                            sx: {
                                color: "common.white",
                                mb: 5
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h2",
                                children: contentfulDataFragment.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                            variants: (0,animate/* varFade */.EU)().inDown,
                            children: contacts === null || contacts === void 0 ? void 0 : contacts.map(function(contact) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    spacing: 1.5,
                                    direction: "row",
                                    alignItems: "center",
                                    sx: {
                                        mb: 3,
                                        px: 5
                                    },
                                    children: [
                                        contactIcons.find(function(icon) {
                                            return icon.type === contact.text;
                                        }) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                            icon: ((ref = contactIcons.find(function(icon) {
                                                return icon.type === contact.text;
                                            })) === null || ref === void 0 ? void 0 : ref.icon) || "",
                                            sx: {
                                                width: 30,
                                                height: 30,
                                                color: "white"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: contact.text === "email" ? "mailto: ".concat(contact.link) : (_link = contact.link) !== null && _link !== void 0 ? _link : undefined,
                                            target: "_blank",
                                            rel: "noopener",
                                            variant: "body1",
                                            sx: {
                                                color: "white"
                                            },
                                            children: contact.text === "email" ? contact.link : contact.text
                                        })
                                    ]
                                }, contact.text);
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/landing/LandingFeaturesList.tsx


function LandingFeaturesList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  background: ",
        ";\n  border-radius: 100%;\n  padding: 10px;\n  color: white;\n"
    ]);
    LandingFeaturesList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LandingFeaturesList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  width: ",
        "px;\n  height: ",
        "px;\n  border-radius: 100%;\n  padding: 10px;\n"
    ]);
    LandingFeaturesList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LandingFeaturesList_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    LandingFeaturesList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var CardStyle = (0,styled/* default */.ZP)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    var shadowCard = function(opacity) {
        return theme.palette.mode === "light" ? (0,colorManipulator/* alpha */.Fq)(theme.palette.grey[500], opacity) : (0,colorManipulator/* alpha */.Fq)(theme.palette.common.black, opacity);
    };
    var _obj;
    return _obj = {
        opacity: 0.9,
        maxWidth: 380,
        minHeight: 250,
        height: "100%",
        margin: "auto",
        textAlign: "center",
        padding: theme.spacing(5),
        boxShadow: theme.customShadows.z12,
        transition: "all 0.2s"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
        boxShadow: "none",
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800]
    }), (0,_define_property/* default */.Z)(_obj, "&.cardLeft", (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
        marginTop: -40
    })), (0,_define_property/* default */.Z)(_obj, "&.cardCenter", (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
        marginTop: -80,
        backgroundColor: theme.palette.background.paper,
        boxShadow: "-40px 40px 80px 0 ".concat(shadowCard(0.4)),
        "&:before": {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: -1,
            content: "''",
            margin: "auto",
            position: "absolute",
            width: "calc(100% - 40px)",
            height: "calc(100% - 40px)",
            borderRadius: Number(theme.shape.borderRadius) * 2,
            backgroundColor: theme.palette.background.paper,
            boxShadow: "-20px 20px 40px 0 ".concat(shadowCard(0.12))
        }
    })), _obj;
});
var imageSize = 80;
var _backgroundColor;
var StyledIconify = (0,styled_components_browser_esm/* default */.ZP)(Iconify/* default */.Z).withConfig({
    componentId: "sc-e534974b-0"
})(LandingFeaturesList_templateObject(), imageSize, imageSize, function(props) {
    return (_backgroundColor = props.backgroundColor) !== null && _backgroundColor !== void 0 ? _backgroundColor : "transparent";
});
var _backgroundColor1;
var LandingFeaturesList_Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-e534974b-1"
})(LandingFeaturesList_templateObject1(), function(props) {
    return (_backgroundColor1 = props.backgroundColor) !== null && _backgroundColor1 !== void 0 ? _backgroundColor1 : "transparent";
}, imageSize, imageSize);
var IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e534974b-2"
})(LandingFeaturesList_templateObject2());
function LandingFeatureList(props) {
    var ref;
    var contentfulDataFragment = props.contentfulDataFragment, backgroundColor = props.backgroundColor, globalSetting = props.globalSetting;
    var theme = (0,useTheme/* default */.Z)();
    var ref1;
    var cards = (ref1 = (ref = contentfulDataFragment.componentsCollection) === null || ref === void 0 ? void 0 : ref.items) !== null && ref1 !== void 0 ? ref1 : [];
    var ref2;
    var iconWrapperColor = (0,colorManipulator/* alpha */.Fq)((ref2 = globalSetting === null || globalSetting === void 0 ? void 0 : globalSetting.companyColor) !== null && ref2 !== void 0 ? ref2 : theme.palette.primary.main, 0.8);
    var _title, _description, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            sx: {
                position: "relative",
                mb: 10,
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                    title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 5,
                    direction: "row",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    children: cards.map(function(card, index) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardStyle, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                        children: (card === null || card === void 0 ? void 0 : card.iconifyIconName) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconify, {
                                            icon: card.iconifyIconName,
                                            backgroundColor: iconWrapperColor
                                        }) : (card === null || card === void 0 ? void 0 : (ref = card.icon) === null || ref === void 0 ? void 0 : ref.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingFeaturesList_Image, {
                                            src: card.icon.url,
                                            alt: (ref3 = card === null || card === void 0 ? void 0 : card.title) !== null && ref3 !== void 0 ? ref3 : "",
                                            backgroundColor: iconWrapperColor
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconify, {
                                            icon: "line-md:github-loop",
                                            backgroundColor: iconWrapperColor
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        paragraph: true,
                                        style: {
                                            marginTop: 8
                                        },
                                        children: card === null || card === void 0 ? void 0 : card.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        children: card === null || card === void 0 ? void 0 : card.description
                                    })
                                ]
                            })
                        }, ((ref4 = card === null || card === void 0 ? void 0 : card.title) !== null && ref4 !== void 0 ? ref4 : "") + index);
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/web3/lib/index.js
var web3_lib = __webpack_require__(3283);
var lib_default = /*#__PURE__*/__webpack_require__.n(web3_lib);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormLabel/FormLabel.js
var FormLabel = __webpack_require__(40476);
// EXTERNAL MODULE: ./node_modules/@mui/material/RadioGroup/RadioGroup.js + 2 modules
var RadioGroup = __webpack_require__(72890);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Radio/Radio.js + 6 modules
var Radio = __webpack_require__(49033);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/@web3-react/injected-connector/dist/injected-connector.esm.js + 1 modules
var injected_connector_esm = __webpack_require__(49857);
;// CONCATENATED MODULE: ./src/components/wallet/connectors.ts

var injected = new injected_connector_esm/* InjectedConnector */._k({
    supportedChainIds: [
        1,
        3,
        4,
        5,
        42
    ]
});

// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js + 1 modules
var core_esm = __webpack_require__(34713);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/big.js/big.js
var big = __webpack_require__(93302);
var big_default = /*#__PURE__*/__webpack_require__.n(big);
;// CONCATENATED MODULE: ./src/utils/calculation/index.ts
// @ts-nocheck


var RM = {
    ROUND_DOWN: 0,
    ROUND_HALF_UP: 1,
    ROUND_HALF_EVEN: 2,
    ROUND_UP: 3
};
(big_default()).RM = RM.ROUND_DOWN;
var catchWraper = function(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        try {
            return fn.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
        } catch (e) {
            return undefined;
        }
    };
};
var OperationGenerator = function(op) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return args.reduce(function(sum, val) {
            return sum ? sum[op](val) : big_default()(val);
        }, undefined).toFixed();
    };
};
var ComparisonGenerator = function(op) {
    return function(arg1, arg2) {
        return big_default()(arg1)[op](big_default()(arg2));
    };
};
var add = catchWraper(OperationGenerator("plus"));
var sub = catchWraper(OperationGenerator("minus"));
var mul = catchWraper(OperationGenerator("times"));
var div = catchWraper(OperationGenerator("div"));
var mod = catchWraper(OperationGenerator("mod"));
var cmp = catchWraper(OperationGenerator("cmp"));
var eq = catchWraper(ComparisonGenerator("eq"));
var gte = catchWraper(ComparisonGenerator("gte"));
var lte = catchWraper(ComparisonGenerator("lte"));
var gt = catchWraper(ComparisonGenerator("gt"));
var lt = catchWraper(ComparisonGenerator("lt"));
var round = catchWraper(function(num) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10, type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : RM.ROUND_DOWN;
    return big_default()(num).round(precision, type).toFixed();
});
var toPrecision = catchWraper(function(num, precision) {
    return big_default()(num).toPrecision(precision);
});
var toFixed = catchWraper(function(num, precision) {
    return big_default()(num).toFixed(precision);
});
var average = function() {
    var numbers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var sum = numbers.reduce(function(acc, num) {
        return add(acc, num);
    }, "0");
    return div(sum, numbers.length);
};
/*
  0-800	0 SLP per win
  800-999	1 SLP per win
  1000-1099	3 SLP per win
  1100-1299	6 SLP per win
  1300-1499	9 SLP per win
  1500-1799	12 SLP per win
  1800-1999	15 SLP per win
  2000-2199	18 SLP per win
  2200+	21 SLP per win
*/ var slpEstimation = function(param) {
    var mmr = param.mmr, winRate = param.winRate, _axieCount = param.axieCount, axieCount = _axieCount === void 0 ? "3" : _axieCount;
    var slpWinPerGame = "0";
    var energy = "0";
    if (gte(axieCount, "20")) {
        energy = "60";
    } else if (gte(axieCount, "10")) {
        energy = "40";
    } else if (gte(axieCount, "3")) {
        energy = "20";
    } else {
        energy = "0";
    }
    if (gte(mmr, "2200")) {
        slpWinPerGame = "21";
    } else if (gte(mmr, "2000")) {
        slpWinPerGame = "18";
    } else if (gte(mmr, "1800")) {
        slpWinPerGame = "15";
    } else if (gte(mmr, "1500")) {
        slpWinPerGame = "12";
    } else if (gte(mmr, "1300")) {
        slpWinPerGame = "9";
    } else if (gte(mmr, "1100")) {
        slpWinPerGame = "6";
    } else if (gte(mmr, "1000")) {
        slpWinPerGame = "3";
    } else if (gte(mmr, "800")) {
        slpWinPerGame = "1";
    } else {
        slpWinPerGame = "0";
    }
    var calWinRate = gt(winRate !== null && winRate !== void 0 ? winRate : "0", "0") ? winRate : "50";
    var gainedSlpGamesCount = mul(energy, div(calWinRate, "100"));
    var result = mul(gainedSlpGamesCount, slpWinPerGame);
    return result;
};

// EXTERNAL MODULE: ./src/components/Label.tsx
var Label = __webpack_require__(4930);
// EXTERNAL MODULE: ./src/appConfig.ts + 1 modules
var appConfig = __webpack_require__(83330);
;// CONCATENATED MODULE: ./src/contracts/xtf-abi.json
var xtf_abi_namespaceObject = JSON.parse('[{"inputs":[{"internalType":"string","name":"_initBaseURI","type":"string"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address[]","name":"_addresses","type":"address[]"}],"name":"airdrop","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseExtension","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cost","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxMintAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"merkleRoot","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_mintAmount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_mintAmount","type":"uint256"}],"name":"mintOwner","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_mintAmount","type":"uint256"},{"internalType":"bytes32[]","name":"_merkleProof","type":"bytes32[]"}],"name":"mintWhitelist","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"nftPerAddressLimit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"onlyWhitelisted","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"presaleAddressMintedBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"saleIsActive","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_newBaseExtension","type":"string"}],"name":"setBaseExtension","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_newBaseURI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newCost","type":"uint256"}],"name":"setCost","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"_merkleRoot","type":"bytes32"}],"name":"setMerkleRoot","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_limit","type":"uint256"}],"name":"setNftPerAddressLimit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"_state","type":"bool"}],"name":"setOnlyWhitelisted","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"_state","type":"bool"}],"name":"setSaleState","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_startTimestamp","type":"uint256"}],"name":"setStartTimestamp","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_state","type":"uint256"}],"name":"setWhiteListPhaseMaxMint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newmaxMintAmount","type":"uint256"}],"name":"setmaxMintAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"startTimestamp","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"walletOfOwner","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"whiteListPhaseMaxMint","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"payable","type":"function"}]');
;// CONCATENATED MODULE: ./src/sections/pricing/MintCard.tsx




function MintCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 27px;\n  margin-right: 12px;\n"
    ]);
    MintCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MintCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: 20px;\n  grid-template-columns: repeat(1, 1fr);\n  width: 100%;\n"
    ]);
    MintCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MintCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-radius: 10px;\n  border: transparent !important;\n"
    ]);
    MintCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: white;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #8bacda;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #00fff7;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      && {\n        border: 1px solid #ffffff22;\n        background-color: #282c34 !important;\n        background: linear-gradient(\n          0deg,\n          rgba(40, 44, 52, 1) 0%,\n          rgba(17, 0, 32, 0.5) 100%\n        ) !important;\n        box-shadow: 0 7px 20px 5px #00000088;\n        overflow: hidden;\n        transition: 0.5s all;\n      }\n      &::before {\n        position: fixed;\n        content: '';\n        box-shadow: 0 0 30px 100px #ffffff08;\n        top: -10%;\n        left: -100%;\n        transform: rotate(-45deg);\n        height: 60rem;\n        transition: 0.7s all;\n      }\n      &:hover {\n        border: 1px solid #ffffff44;\n        box-shadow: 0 7px 50px 10px #000000aa;\n        transform: scale(1.015);\n        filter: brightness(1.3);\n        ::before {\n          filter: brightness(0.5);\n          top: -100%;\n          left: 200%;\n        }\n      }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: #fff !important;\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n\n      ",
        " {\n        position: relative;\n        padding-bottom: 20px;\n        color: #372f2b;\n        &::after {\n          display: block;\n          position: absolute;\n          bottom: 0px;\n          content: '';\n          width: 40px;\n          height: 2px;\n          background: #3b86c4;\n        }\n      }\n      ",
        " {\n        color: #5f5f5f;\n      }\n      ",
        " {\n        color: #3b86c4;\n      }\n      ",
        " {\n        filter: invert(46%) sepia(88%) saturate(394%) hue-rotate(164deg) brightness(89%)\n          contrast(85%);\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  grid-gap: 15px;\n  width: 100%;\n  max-width: 500px;\n  margin: auto;\n  position: relative;\n  align-items: center;\n  flex-direction: column;\n  border-radius: 10px;\n  background: #1b335a !important;\n  border: transparent !important;\n  padding: 60px;\n  grid-gap: 18px;\n\n  @media (max-width: 768px) {\n    padding: 30px;\n    grid-gap: 15px;\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
var ref;

















var xtfConfig = lodash_default().find(appConfig/* appsConfigs */.gY, {
    appId: appConfig/* AppIdEnum.xtf */._S.xtf
});
var _contractAddress;
var xtfAddr = (_contractAddress = xtfConfig === null || xtfConfig === void 0 ? void 0 : (ref = xtfConfig.smartContract) === null || ref === void 0 ? void 0 : ref["0xC04acbD5BD1694Fd09d195Ab014875a21793f38D"].contractAddress) !== null && _contractAddress !== void 0 ? _contractAddress : "0xC04acbD5BD1694Fd09d195Ab014875a21793f38D";
var MintCard_utils = (lib_default()).utils;
var StyledIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-62b71ead-0"
})(MintCard_templateObject());
var FormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-62b71ead-1"
})(MintCard_templateObject1());
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-62b71ead-2"
})(MintCard_templateObject2());
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    componentId: "sc-62b71ead-3"
})(_templateObject3());
var StyledDescription = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    componentId: "sc-62b71ead-4"
})(_templateObject4());
var StyledPrice = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-62b71ead-5"
})(_templateObject5());
var StyledButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-62b71ead-6"
})(_templateObject6());
var MintCard_RootStyle = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-62b71ead-7"
})(_templateObject9(), function(props) {
    return props.cardVariant === MintCardVariantEnum.shiny && (0,styled_components_browser_esm/* css */.iv)(_templateObject7());
}, function(props) {
    return props.cardVariant === MintCardVariantEnum.white && (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), StyledTitle, StyledDescription, StyledPrice, StyledIcon);
});
var isCorrectNetwork = function(chainId, data) {
    switch(chainId){
        case 1:
            var ref;
            return ((ref = data.smartContractErc721) === null || ref === void 0 ? void 0 : ref.network) === "ethereum mainnet";
        case 4:
            var ref1;
            return ((ref1 = data.smartContractErc721) === null || ref1 === void 0 ? void 0 : ref1.network) === "ethereum rinkeby";
        case 5:
            var ref2;
            return ((ref2 = data.smartContractErc721) === null || ref2 === void 0 ? void 0 : ref2.network) === "ethereum goerli";
        default:
            return false;
    }
};
var ClaimComponent = function(props) {
    var ref, ref1, ref2, ref3;
    var contentfulDataFragment = props.contentfulDataFragment;
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var ref4 = (0,core_esm/* useWeb3React */.Ge)(), account = ref4.account, library = ref4.library, chainId = ref4.chainId;
    var ref5 = (0,react.useState)(null), claimableTokenIds = ref5[0], setClaimableTokenIds = ref5[1];
    var ref6 = (0,react.useState)(null), selectedTokenId = ref6[0], setSelectedTokenId = ref6[1];
    var ref7 = (0,react.useState)(false), isLoading = ref7[0], setIsLoading = ref7[1];
    var dependencySmartContractAddress = (ref = contentfulDataFragment.dependencySmartContractErc721) === null || ref === void 0 ? void 0 : ref.smartContractAddress;
    var dependencySmartContractAbi = (ref1 = contentfulDataFragment.dependencySmartContractErc721) === null || ref1 === void 0 ? void 0 : ref1.abi;
    var claimContractAddress = (ref2 = contentfulDataFragment.smartContractErc721) === null || ref2 === void 0 ? void 0 : ref2.smartContractAddress;
    var claimContractAbi = (ref3 = contentfulDataFragment.smartContractErc721) === null || ref3 === void 0 ? void 0 : ref3.abi;
    (0,react.useEffect)(function() {
        var interval = setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var dependencyContract, claimContract;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!dependencySmartContractAddress || !dependencySmartContractAbi || !account || !claimContractAddress || !claimContractAbi) return [
                    2
                ];
                if ((0,_instanceof/* default */.Z)(library, (lib_default()))) {
                    dependencyContract = new library.eth.Contract(dependencySmartContractAbi, dependencySmartContractAddress);
                    claimContract = new library.eth.Contract(claimContractAbi, claimContractAddress);
                    dependencyContract.methods.walletOfOwner(account).call().then(function(tokenIds) {
                        Promise.all(tokenIds.map(function(tokenId) {
                            return claimContract.methods.nftTokenHadClaimed(tokenId).call().then(function(bool) {
                                return {
                                    tokenId: tokenId,
                                    claimed: bool
                                };
                            });
                        })).then(function(results) {
                            return setClaimableTokenIds(results);
                        });
                    });
                }
                return [
                    2
                ];
            });
        }), 1000);
        return function() {
            clearInterval(interval);
        };
    }, [
        chainId,
        library
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormLabel/* default */.Z, {
                        id: "demo-controlled-radio-buttons-group",
                        children: "可領空頭的NFT"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
                        "aria-labelledby": "demo-controlled-radio-buttons-group",
                        name: "controlled-radio-buttons-group",
                        value: selectedTokenId,
                        onChange: function(_e, value) {
                            return setSelectedTokenId(value);
                        },
                        children: claimableTokenIds === null ? null : claimableTokenIds.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: "很抱歉,您沒有可以領空頭的NFT"
                        }) : claimableTokenIds.map(function(claimableTokenId) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                disabled: claimableTokenId.claimed,
                                value: claimableTokenId.tokenId,
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                label: "NFT編號 (".concat(claimableTokenId.tokenId, ") ").concat(claimableTokenId.claimed ? "(此NFT已領過空頭)" : "")
                            }, claimableTokenId.tokenId);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                disabled: selectedTokenId === null || isLoading,
                fullWidth: true,
                size: "large",
                variant: "contained",
                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var contract, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!claimContractAddress || !claimContractAbi) return [
                                    2
                                ];
                                setIsLoading(true);
                                contract = new library.eth.Contract(claimContractAbi, claimContractAddress);
                                if (!((0,_instanceof/* default */.Z)(library, (lib_default())) && contract && account)) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    contract.methods.claim(selectedTokenId).send({
                                        value: "0",
                                        from: account
                                    })
                                ];
                            case 2:
                                _state.sent();
                                setSelectedTokenId(null);
                                enqueueSnackbar("Claim Successfully", {
                                    variant: "success"
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                if (error.code === 4001) {
                                    enqueueSnackbar(error.message, {
                                        variant: "info"
                                    });
                                } else {
                                    enqueueSnackbar("Something went wrong", {
                                        variant: "warning"
                                    });
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    setIsLoading(false)
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }),
                loading: isLoading,
                children: "Claim"
            })
        ]
    });
};
var MintWhitelistComponent = function(props) {
    var ref, ref1;
    var setPriceEthFunction = props.setPriceEthFunction, contentfulDataFragment = props.contentfulDataFragment, priceEth = props.priceEth;
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var theme = (0,useTheme/* default */.Z)();
    var ref2 = (0,core_esm/* useWeb3React */.Ge)(), account = ref2.account, library = ref2.library, chainId = ref2.chainId;
    var ref3 = (0,react.useState)("0"), nftPerAddressLimit = ref3[0], setNftPerAddressLimit = ref3[1];
    var ref4 = (0,react.useState)("0"), currentUserMinted = ref4[0], setCurrentUserMinted = ref4[1];
    var ref5 = (0,react.useState)("1"), mintingAmount = ref5[0], setMintAmount = ref5[1];
    var remainingMintableAmount = sub(nftPerAddressLimit, currentUserMinted);
    var ref6 = (0,react.useState)(false), isLoading = ref6[0], setIsLoading = ref6[1];
    var contractAddress = (ref = contentfulDataFragment.smartContractErc721) === null || ref === void 0 ? void 0 : ref.smartContractAddress;
    var abi = (ref1 = contentfulDataFragment.smartContractErc721) === null || ref1 === void 0 ? void 0 : ref1.abi;
    (0,react.useEffect)(function() {
        var interval = setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var contract;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!contractAddress || !abi) return [
                    2
                ];
                if ((0,_instanceof/* default */.Z)(library, (lib_default())) && contractAddress) {
                    contract = new library.eth.Contract(abi, contractAddress);
                    contract.methods.nftPerAddressLimit().call().then(function(r) {
                        setNftPerAddressLimit(r);
                    });
                    contract.methods.presaleAddressMintedBalance(account).call().then(function(r) {
                        setCurrentUserMinted(r);
                    });
                    contract.methods.cost().call().then(function(r) {
                        setPriceEthFunction(MintCard_utils.fromWei(r, "ether"));
                    });
                }
                return [
                    2
                ];
            });
        }), 1000);
        return function() {
            clearInterval(interval);
        };
    }, [
        chainId,
        library
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                type: "text",
                size: "small",
                value: mintingAmount,
                fullWidth: true,
                InputProps: {
                    sx: {
                        color: theme.palette.primary.main
                    }
                },
                onChange: function(e) {
                    return setMintAmount(e.target.value);
                },
                helperText: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "caption",
                        children: [
                            "Remaining Mintable amount: ",
                            remainingMintableAmount
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                disabled: Number(remainingMintableAmount) <= 0,
                fullWidth: true,
                size: "large",
                variant: "contained",
                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var contract, result, data, proofs, proof, merkleProof, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!contractAddress || !abi) return [
                                    2
                                ];
                                setIsLoading(true);
                                contract = new library.eth.Contract(abi, contractAddress);
                                if (!((0,_instanceof/* default */.Z)(library, (lib_default())) && contractAddress && account)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    axios_default()("/api/erc721/".concat(contractAddress, "/merkleTree/"))
                                ];
                            case 1:
                                result = _state.sent();
                                data = result.data;
                                proofs = lodash_default().get(data, [
                                    "output",
                                    "proofs"
                                ]);
                                proof = lodash_default().find(proofs, {
                                    address: account
                                });
                                if (!proof) {
                                    setIsLoading(false);
                                    return [
                                        2,
                                        enqueueSnackbar("You are not in the whitelist", {
                                            variant: "info"
                                        })
                                    ];
                                }
                                merkleProof = proof.hexProof;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    contract.methods.mintWhitelist(mintingAmount, merkleProof).send({
                                        value: MintCard_utils.toWei(mul(mintingAmount, priceEth), "ether"),
                                        from: account
                                    })
                                ];
                            case 3:
                                _state.sent();
                                enqueueSnackbar("Minted Successfully", {
                                    variant: "success"
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                if (error.code === 4001) {
                                    enqueueSnackbar(error.message, {
                                        variant: "info"
                                    });
                                } else {
                                    enqueueSnackbar("Something went wrong", {
                                        variant: "warning"
                                    });
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    setIsLoading(false)
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }),
                loading: isLoading,
                children: "Mint"
            })
        ]
    });
};
var MintComponent = function(props) {
    var ref, ref1;
    var setPriceEthFunction = props.setPriceEthFunction, contentfulDataFragment = props.contentfulDataFragment, priceEth = props.priceEth;
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var theme = (0,useTheme/* default */.Z)();
    var ref2 = (0,core_esm/* useWeb3React */.Ge)(), account = ref2.account, library = ref2.library, chainId = ref2.chainId;
    var ref3 = (0,react.useState)("1"), mintingAmount = ref3[0], setMintAmount = ref3[1];
    var ref4 = (0,react.useState)(false), isLoading = ref4[0], setIsLoading = ref4[1];
    var contractAddress = (ref = contentfulDataFragment.smartContractErc721) === null || ref === void 0 ? void 0 : ref.smartContractAddress;
    var abi = contractAddress === xtfAddr ? xtf_abi_namespaceObject : (ref1 = contentfulDataFragment.smartContractErc721) === null || ref1 === void 0 ? void 0 : ref1.abi;
    (0,react.useEffect)(function() {
        var interval = setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var contract;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!contractAddress || !abi) return [
                    2
                ];
                if ((0,_instanceof/* default */.Z)(library, (lib_default())) && contractAddress) {
                    contract = new library.eth.Contract(abi, contractAddress);
                    contract.methods.cost().call().then(function(r) {
                        setPriceEthFunction(MintCard_utils.fromWei(r, "ether"));
                    });
                }
                return [
                    2
                ];
            });
        }), 1000);
        return function() {
            clearInterval(interval);
        };
    }, [
        chainId,
        library
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                type: "text",
                size: "small",
                value: mintingAmount,
                fullWidth: true,
                InputProps: {
                    sx: {
                        color: theme.palette.primary.main
                    }
                },
                onChange: function(e) {
                    return setMintAmount(e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                fullWidth: true,
                size: "large",
                variant: "contained",
                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var contract, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!contractAddress || !abi) return [
                                    2
                                ];
                                setIsLoading(true);
                                contract = new library.eth.Contract(abi, contractAddress);
                                if (!((0,_instanceof/* default */.Z)(library, (lib_default())) && contractAddress && account)) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    contract.methods.mint(mintingAmount).send({
                                        value: MintCard_utils.toWei(mul(mintingAmount, priceEth), "ether"),
                                        from: account
                                    })
                                ];
                            case 2:
                                _state.sent();
                                enqueueSnackbar("Minted Successfully", {
                                    variant: "success"
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                if (error.code === 4001) {
                                    enqueueSnackbar(error.message, {
                                        variant: "info"
                                    });
                                } else {
                                    enqueueSnackbar("Something went wrong", {
                                        variant: "warning"
                                    });
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    setIsLoading(false)
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }),
                loading: isLoading,
                children: "Mint"
            })
        ]
    });
};
var MintCardVariantEnum;
(function(MintCardVariantEnum) {
    MintCardVariantEnum["card"] = "card";
    MintCardVariantEnum["section"] = "section";
    MintCardVariantEnum["shiny"] = "shiny";
    MintCardVariantEnum["white"] = "white";
})(MintCardVariantEnum || (MintCardVariantEnum = {}));
function MintCard(props) {
    var ref, ref1, ref2, ref3;
    var contentfulDataFragment = props.contentfulDataFragment;
    var ref4 = (0,core_esm/* useWeb3React */.Ge)(), active = ref4.active, account = ref4.account, activate = ref4.activate, chainId = ref4.chainId;
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var ref5 = (0,react.useState)(null), priceEth = ref5[0], setPriceEth = ref5[1];
    function connect() {
        return _connect.apply(this, arguments);
    }
    function _connect() {
        _connect = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                activate(injected, function(error) {
                    switch(error.name){
                        case "NoEthereumProviderError":
                            {
                                return enqueueSnackbar("找不到您的狐狸錢包", {
                                    variant: "warning"
                                });
                            }
                        default:
                            return enqueueSnackbar("請確認您的狐狸錢包正確的連結到網頁", {
                                variant: "warning"
                            });
                    }
                });
                return [
                    2
                ];
            });
        });
        return _connect.apply(this, arguments);
    }
    var renderCallToActionView = function() {
        switch(contentfulDataFragment.smartContractCallToActionName){
            case "mintWhitelist":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MintWhitelistComponent, {
                        contentfulDataFragment: contentfulDataFragment,
                        setPriceEthFunction: setPriceEth,
                        priceEth: priceEth
                    });
                }
            case "claim":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClaimComponent, {
                        contentfulDataFragment: contentfulDataFragment
                    });
                }
            case "mint":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MintComponent, {
                        contentfulDataFragment: contentfulDataFragment,
                        setPriceEthFunction: setPriceEth,
                        priceEth: priceEth
                    });
                }
            default:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                            fullWidth: true,
                            size: "large",
                            variant: "contained",
                            disabled: true,
                            children: "DEFAULT"
                        })
                    });
                }
        }
    };
    var variant = (0,es/* $enum */.o6)(MintCardVariantEnum).getValues().includes(contentfulDataFragment.style) ? contentfulDataFragment.style : MintCardVariantEnum.card;
    var ref6, _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MintCard_RootStyle, {
        cardVariant: variant,
        children: [
            ((ref = contentfulDataFragment.smartContractErc721) === null || ref === void 0 ? void 0 : ref.network) !== "ethereum mainnet" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                variant: "filled",
                color: "warning",
                sx: {
                    zIndex: 9,
                    top: 16,
                    right: 16,
                    position: "absolute"
                },
                children: (ref1 = contentfulDataFragment.smartContractErc721) === null || ref1 === void 0 ? void 0 : ref1.network
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                src: (ref6 = (ref2 = contentfulDataFragment.smartContractErc721) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.displayImage) === null || ref3 === void 0 ? void 0 : ref3.url) !== null && ref6 !== void 0 ? ref6 : "",
                alt: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                variant: "h4",
                style: {
                    textAlign: "left"
                },
                children: contentfulDataFragment.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescription, {
                variant: "h6",
                children: contentfulDataFragment.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPrice, {
                style: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                        src: "/icons/icon-ethereum.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "h5",
                        style: {
                            textAlign: "left"
                        },
                        children: [
                            priceEth !== null && priceEth !== void 0 ? priceEth : contentfulDataFragment.price,
                            " ETH"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonContainer, {
                children: !account || !active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    fullWidth: true,
                    variant: "outlined",
                    onClick: connect,
                    children: "Connect to MetaMask"
                }) : isCorrectNetwork(chainId, contentfulDataFragment) === false ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    disabled: true,
                    fullWidth: true,
                    variant: "outlined",
                    children: "Wrong Network"
                }) : renderCallToActionView()
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/landing/LandingMintList.tsx







function LandingMintList(props) {
    var ref;
    var backgroundColor = props.backgroundColor, contentfulDataFragment = props.contentfulDataFragment;
    var theme = (0,useTheme/* default */.Z)();
    var ref1;
    var cards = (ref1 = (ref = contentfulDataFragment.mintCardsCollection) === null || ref === void 0 ? void 0 : ref.items) !== null && ref1 !== void 0 ? ref1 : [];
    var _title, _description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                    title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    justifyContent: "center",
                    alignItems: "center",
                    children: cards.filter(function(card) {
                        return (card === null || card === void 0 ? void 0 : card.isDisplay) !== false;
                    }).map(function(card, cardIndex) {
                        var ref;
                        var data = (0,_object_spread/* default */.Z)({}, card);
                        var isSectionStyle = data.style === "section";
                        var ref1;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: isSectionStyle ? 12 : 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                variants: (0,animate/* varFade */.EU)().in,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MintCard, {
                                    contentfulDataFragment: data
                                })
                            })
                        }, ((ref1 = card === null || card === void 0 ? void 0 : (ref = card.smartContractErc721) === null || ref === void 0 ? void 0 : ref.smartContractAddress) !== null && ref1 !== void 0 ? ref1 : "") + cardIndex);
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/hooks/useCountdown.ts

// ----------------------------------------------------------------------
function useCountdown(date) {
    var ref = (0,react.useState)({
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00"
    }), countdown = ref[0], setCountdown = ref[1];
    (0,react.useEffect)(function() {
        if (date.valueOf() - new Date().valueOf() <= 0) return;
        var interval = setInterval(function() {
            return setNewTime();
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var setNewTime = function() {
        var startTime = date;
        var endTime = new Date();
        var distanceToNow = startTime.valueOf() - endTime.valueOf();
        if (distanceToNow <= 0) return;
        var getDays = Math.floor(distanceToNow / (1000 * 60 * 60 * 24));
        var getHours = "0".concat(Math.floor(distanceToNow % (1000 * 60 * 60 * 24) / (1000 * 60 * 60))).slice(-2);
        var getMinutes = "0".concat(Math.floor(distanceToNow % (1000 * 60 * 60) / (1000 * 60))).slice(-2);
        var getSeconds = "0".concat(Math.floor(distanceToNow % (1000 * 60) / 1000)).slice(-2);
        setCountdown({
            days: getDays.toString() || "000",
            hours: getHours || "000",
            minutes: getMinutes || "000",
            seconds: getSeconds || "000"
        });
    };
    return countdown;
} // Usage
 // const countdown = useCountdown(new Date('07/07/2022 21:30'));

// EXTERNAL MODULE: ./src/hooks/useLocales.ts + 3 modules
var useLocales = __webpack_require__(67918);
;// CONCATENATED MODULE: ./src/sections/landing/LandingTimer.tsx









var CountdownItemStyle = (0,styled/* default */.ZP)("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
});
var StyledTimerTime = (0,styled/* default */.ZP)(Typography/* default */.Z)(function(param) {
    var theme = param.theme, appearance = param.appearance;
    return (0,_object_spread/* default */.Z)({
        textAlign: "center"
    }, appearance === TimerAppearanceEnum.digital && (0,_define_property/* default */.Z)({
        fontFamily: "Orbitron !important"
    }, theme.breakpoints.down("sm"), {
        fontSize: "1.6rem !important"
    }));
});
var StyledTimerUnit = (0,styled/* default */.ZP)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.primary.main,
        "&:first-letter": {
            textTransform: "uppercase"
        }
    };
});
var StyledCountdownTime = (0,styled/* default */.ZP)(Card/* default */.Z)(function(param) {
    var theme = param.theme, appearance = param.appearance;
    return (0,_object_spread/* default */.Z)((0,_define_property/* default */.Z)({
        padding: theme.spacing(1.5),
        marginBottom: theme.spacing(1),
        minWidth: "65px"
    }, theme.breakpoints.up("sm"), {
        padding: theme.spacing(3.5),
        marginBottom: theme.spacing(2),
        minWidth: "130px"
    }), appearance === TimerAppearanceEnum.digital && {
        border: "1px solid ".concat(theme.palette.primary.main),
        background: "rgba(255, 255, 255, 0.03)",
        color: theme.palette.common.white,
        overflow: "hidden",
        transition: "0.5s all"
    });
});
var StyledCountdown = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        marginTop: theme.spacing(12),
        marginBottom: theme.spacing(12),
        display: "flex",
        justifyContent: "center",
        gap: theme.spacing(1.5)
    }, theme.breakpoints.up("md"), {
        gap: theme.spacing(3)
    });
});
var TimerAppearanceEnum;
(function(TimerAppearanceEnum) {
    TimerAppearanceEnum["default"] = "default";
    TimerAppearanceEnum["digital"] = "digital";
})(TimerAppearanceEnum || (TimerAppearanceEnum = {}));
function LandingTimer(props) {
    var translate = (0,useLocales/* default */.Z)().translate;
    var contentfulDataFragment = props.contentfulDataFragment, backgroundColor = props.backgroundColor;
    var countdown = useCountdown(new Date(contentfulDataFragment.startTime));
    var theme = (0,useTheme/* default */.Z)();
    var appearance = Object.values(TimerAppearanceEnum).includes(contentfulDataFragment.appearance) ? contentfulDataFragment.appearance : TimerAppearanceEnum.default;
    var CountdownTime = function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCountdownTime, {
            appearance: appearance,
            children: children
        });
    };
    var TimerTime = function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerTime, {
            variant: "h2",
            appearance: appearance,
            children: children
        });
    };
    var _title, _description;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                    title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCountdown, {
                    appearance: appearance,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CountdownItemStyle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownTime, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimerTime, {
                                        children: countdown.days
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerUnit, {
                                    children: translate("unit.days")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CountdownItemStyle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownTime, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimerTime, {
                                        children: countdown.hours
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerUnit, {
                                    children: translate("unit.hours")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CountdownItemStyle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownTime, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimerTime, {
                                        children: countdown.minutes
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerUnit, {
                                    children: translate("unit.minutes")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CountdownItemStyle, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownTime, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimerTime, {
                                        children: countdown.seconds
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimerUnit, {
                                    children: translate("unit.seconds")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./src/components/LightboxModal.tsx
var LightboxModal = __webpack_require__(27602);
// EXTERNAL MODULE: ./src/utils/contentful.ts
var contentful = __webpack_require__(74803);
;// CONCATENATED MODULE: ./src/sections/landing/LandingGallery.tsx
















var CaptionStyle = (0,styled/* default */.ZP)(CardContent/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,cssStyles/* default */.Z)().bgBlur({
        blur: 2,
        color: theme.palette.grey[900]
    })), {
        bottom: 0,
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "absolute",
        justifyContent: "space-between",
        color: theme.palette.common.white
    });
});
function LandingGallery(props) {
    var ref;
    var ref1 = (0,react.useState)(false), isLightBoxOpen = ref1[0], setIsLightBoxOpen = ref1[1];
    var ref2 = (0,react.useState)([]), images = ref2[0], setImages = ref2[1];
    var ref3 = (0,react.useState)(""), loadingItemId = ref3[0], setLoadingItemId = ref3[1];
    var ref4 = (0,react.useState)(0), currentImageIndex = ref4[0], setCurrentImageIndex = ref4[1];
    var locale = (0,next_router.useRouter)().locale;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useFetchSectionImagesByIdForGalleryLazyQuery */.BPu)(), 2), fetchSectionImagesByIdForGalleryLazyQuery = ref5[0], ref6 = ref5[1], fetchSectionImagesByIdForGalleryLazyQueryLoading = ref6.loading, fetchSectionImagesByIdForGalleryLazyQueryData = ref6.data;
    (0,react.useEffect)(function() {
        var ref, ref1;
        var ref2, ref3, ref4, ref5, ref6;
        var images = ((ref2 = fetchSectionImagesByIdForGalleryLazyQueryData === null || fetchSectionImagesByIdForGalleryLazyQueryData === void 0 ? void 0 : (ref = fetchSectionImagesByIdForGalleryLazyQueryData.sectionsMinimalsImagesList) === null || ref === void 0 ? void 0 : (ref1 = ref.imagesCollection) === null || ref1 === void 0 ? void 0 : ref1.items) !== null && ref2 !== void 0 ? ref2 : []).map(function(item) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                sys: {
                    id: (ref3 = item === null || item === void 0 ? void 0 : (ref = item.sys) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : ""
                },
                url: (ref4 = item === null || item === void 0 ? void 0 : item.url) !== null && ref4 !== void 0 ? ref4 : "",
                title: (ref5 = item === null || item === void 0 ? void 0 : item.title) !== null && ref5 !== void 0 ? ref5 : "",
                description: (ref6 = item === null || item === void 0 ? void 0 : item.description) !== null && ref6 !== void 0 ? ref6 : ""
            });
        });
        if (images.length > 0) {
            setImages(images);
        }
    }, [
        fetchSectionImagesByIdForGalleryLazyQueryData
    ]);
    var contentfulDataFragment = props.contentfulDataFragment, backgroundColor = props.backgroundColor;
    var theme = (0,useTheme/* default */.Z)();
    var ref7;
    var items = (ref7 = (ref = contentfulDataFragment.displayItemsCollection) === null || ref === void 0 ? void 0 : ref.items) !== null && ref7 !== void 0 ? ref7 : [];
    var _id, ref8;
    var displayItems = items.map(function(item, itemIndex) {
        var ref, ref1;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            id: (_id = item === null || item === void 0 ? void 0 : item.sys.id) !== null && _id !== void 0 ? _id : String(itemIndex),
            displayImage: (ref8 = item === null || item === void 0 ? void 0 : (ref = item.imagesCollection) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1[0]) !== null && ref8 !== void 0 ? ref8 : {
                sys: {
                    id: "0"
                },
                url: ""
            }
        });
    });
    var _title, _description, _title1, _description1, _url, _url1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                    title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                    subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        display: "grid",
                        gap: 3,
                        gridTemplateColumns: {
                            xs: "repeat(1, 1fr)",
                            sm: "repeat(2, 1fr)",
                            md: "repeat(3, 1fr)"
                        }
                    },
                    children: displayItems.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryItem, {
                            isLoading: fetchSectionImagesByIdForGalleryLazyQueryLoading && item.id === loadingItemId,
                            galleryId: item.id,
                            title: (_title1 = item.title) !== null && _title1 !== void 0 ? _title1 : null,
                            description: (_description1 = item.description) !== null && _description1 !== void 0 ? _description1 : null,
                            image: item.displayImage,
                            onOpenLightbox: function() {
                                setLoadingItemId(item.id);
                                fetchSectionImagesByIdForGalleryLazyQuery({
                                    variables: {
                                        id: item.id,
                                        locale: (0,contentful/* formatLocale */.FF)(locale)
                                    }
                                }).then(function() {
                                    setLoadingItemId("");
                                    setIsLightBoxOpen(true);
                                    setCurrentImageIndex(0);
                                });
                            }
                        }, item.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightboxModal/* default */.Z, {
                    images: images.map(function(image) {
                        return (_url = image.url) !== null && _url !== void 0 ? _url : "";
                    }),
                    mainSrc: images.map(function(image) {
                        return (_url1 = image.url) !== null && _url1 !== void 0 ? _url1 : "";
                    })[currentImageIndex],
                    photoIndex: currentImageIndex,
                    setPhotoIndex: function(photoIndex) {
                        return setCurrentImageIndex(photoIndex);
                    },
                    isOpen: isLightBoxOpen,
                    onCloseRequest: function() {
                        return setIsLightBoxOpen(false);
                    }
                })
            ]
        })
    });
}
function GalleryItem(param) {
    var title = param.title, description = param.description, image = param.image, onOpenLightbox = param.onOpenLightbox, galleryId = param.galleryId, isLoading = param.isLoading;
    var _url = image.url, url = _url === void 0 ? "" : _url;
    var displayUrl = url !== null && url !== void 0 ? url : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        sx: {
            cursor: "pointer",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                alt: "gallery image",
                ratio: "1/1",
                src: displayUrl,
                onClick: function() {
                    return onOpenLightbox(galleryId);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CaptionStyle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                children: title !== null && title !== void 0 ? title : image.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                sx: {
                                    opacity: 0.72
                                },
                                children: description !== null && description !== void 0 ? description : image.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        color: "inherit",
                        onClick: function() {
                            return onOpenLightbox(galleryId);
                        },
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            color: "primary",
                            size: 40
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                            icon: "eva:more-vertical-fill",
                            width: 20,
                            height: 20
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./src/components/hook-form/index.ts + 22 modules
var hook_form = __webpack_require__(48727);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(78470);
;// CONCATENATED MODULE: ./src/sections/landing/landingForm/FormComponent.tsx








function FormComponent(param) {
    var formComponent = param.formComponent;
    var ref;
    var theme = (0,useTheme/* default */.Z)();
    var _label, _placeholder, _helperText, _defaultValue, _defaultChecked, _size, _maxLength, _minLength, _max, _min, _required, _disabled, _readOnly, _defaultChecked1, _fullWidth, _pattern, _multiple, ref1, _step;
    var ref2 = {
        type: formComponent.type,
        label: (_label = formComponent.label) !== null && _label !== void 0 ? _label : "",
        name: formComponent.sys.id,
        placeholder: (_placeholder = formComponent.placeholder) !== null && _placeholder !== void 0 ? _placeholder : undefined,
        helperText: (_helperText = formComponent.helperText) !== null && _helperText !== void 0 ? _helperText : undefined,
        defaultValue: formComponent.type !== "checkbox" && formComponent.type !== "switch" ? (_defaultValue = formComponent.defaultValue) !== null && _defaultValue !== void 0 ? _defaultValue : "" : (_defaultChecked = formComponent.defaultChecked) !== null && _defaultChecked !== void 0 ? _defaultChecked : false,
        size: (_size = formComponent.size) !== null && _size !== void 0 ? _size : undefined,
        maxLength: (_maxLength = formComponent.maxLength) !== null && _maxLength !== void 0 ? _maxLength : undefined,
        minLength: (_minLength = formComponent.minLength) !== null && _minLength !== void 0 ? _minLength : undefined,
        max: (_max = formComponent.max) !== null && _max !== void 0 ? _max : undefined,
        min: (_min = formComponent.min) !== null && _min !== void 0 ? _min : undefined,
        required: (_required = formComponent.required) !== null && _required !== void 0 ? _required : false,
        disabled: (_disabled = formComponent.disabled) !== null && _disabled !== void 0 ? _disabled : false,
        readOnly: (_readOnly = formComponent.readOnly) !== null && _readOnly !== void 0 ? _readOnly : false,
        defaultChecked: (_defaultChecked1 = formComponent.defaultChecked) !== null && _defaultChecked1 !== void 0 ? _defaultChecked1 : false,
        fullWidth: (_fullWidth = formComponent.fullWidth) !== null && _fullWidth !== void 0 ? _fullWidth : false,
        pattern: (_pattern = formComponent.pattern) !== null && _pattern !== void 0 ? _pattern : undefined,
        multiple: (_multiple = formComponent.multiple) !== null && _multiple !== void 0 ? _multiple : false,
        options: (ref1 = (ref = formComponent.options) === null || ref === void 0 ? void 0 : ref.filter(common/* notEmpty */.D)) !== null && ref1 !== void 0 ? ref1 : [],
        step: (_step = formComponent.step) !== null && _step !== void 0 ? _step : undefined
    }, type = ref2.type, label = ref2.label, name = ref2.name, placeholder = ref2.placeholder, helperText = ref2.helperText, defaultValue = ref2.defaultValue, size = ref2.size, maxLength = ref2.maxLength, minLength = ref2.minLength, max = ref2.max, min = ref2.min, required = ref2.required, disabled = ref2.disabled, readOnly = ref2.readOnly, defaultChecked = ref2.defaultChecked, fullWidth = ref2.fullWidth, pattern = ref2.pattern, multiple = ref2.multiple, options = ref2.options, step = ref2.step;
    var SharedTextField = function(_param) /*#__PURE__*/ {
        var type = _param.type, others = (0,_object_without_properties/* default */.Z)(_param, [
            "type"
        ]);
        return (0,jsx_runtime.jsx)(hook_form/* RHFTextField */.au, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, others), {
            type: type,
            style: type === "hidden" ? {
                display: "none"
            } : {},
            placeholder: placeholder,
            name: name,
            label: label,
            defaultValue: defaultValue,
            disabled: disabled,
            required: required,
            fullWidth: fullWidth,
            helperText: helperText,
            size: size,
            inputProps: {
                maxLength: maxLength,
                minLength: minLength,
                max: max,
                min: min,
                readOnly: readOnly,
                pattern: pattern,
                step: step
            }
        }));
    };
    var SharedDatePicker = function(datePickerProps) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(hook_form/* RHFDatePicker */.C5, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, datePickerProps), {
            name: name,
            helperText: helperText,
            defaultValue: defaultValue,
            minDate: min ? moment_default()(min) : undefined,
            maxDate: max ? moment_default()(max) : undefined,
            label: label
        }));
    };
    switch(type){
        case "text":
        case "number":
        case "email":
        case "password":
        case "password":
        case "url":
        case "tel":
        case "hidden":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedTextField, {
                type: type
            });
        case "textarea":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedTextField, {
                type: "textarea",
                multiline: true,
                minRows: 4,
                maxRows: 10
            });
        case "select":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(hook_form/* RHFSelect */.Cc, {
                name: name,
                label: label,
                size: size,
                fullWidth: fullWidth,
                helperText: helperText,
                multiple: multiple,
                defaultValue: defaultValue || (options === null || options === void 0 ? void 0 : options[0]),
                children: options === null || options === void 0 ? void 0 : options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: option,
                        children: option
                    }, option);
                })
            });
        case "radio":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(hook_form/* RHFRadioGroup */.km, {
                name: name,
                label: label,
                options: options
            });
        case "range":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(hook_form/* RHFSlider */.kk, {
                label: label,
                name: name,
                max: Number(max),
                min: Number(min),
                defaultValue: Number(defaultValue),
                step: step,
                size: size,
                disabled: disabled,
                marks: [
                    {
                        value: Number(min),
                        label: min !== null && min !== void 0 ? min : ""
                    },
                    {
                        value: Number(max),
                        label: max !== null && max !== void 0 ? max : ""
                    }, 
                ]
            });
        case "checkbox":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(hook_form/* RHFCheckbox */.jb, {
                defaultChecked: defaultChecked,
                defaultValue: defaultValue,
                label: label,
                name: name
            });
        case "switch":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(hook_form/* RHFSwitch */._e, {
                name: name,
                label: label,
                defaultValue: defaultValue,
                defaultChecked: defaultChecked
            });
        case "date":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedDatePicker, {
                inputFormat: "dd/MM/yyyy",
                rifmFormat: "MM/dd/yyyy"
            });
        case "month":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedDatePicker, {
                views: [
                    "month"
                ],
                inputFormat: "MM"
            });
        case "year":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedDatePicker, {
                views: [
                    "year"
                ],
                inputFormat: "yyyy"
            });
        case "datetime-local":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(hook_form/* RHFDateTimePicker */.g9, {
                name: name,
                label: label,
                helperText: helperText,
                defaultValue: defaultValue,
                inputFormat: "dd/MM/yyyy hh:mm a",
                minDateTime: min ? moment_default()(min) : undefined,
                maxDateTime: max ? moment_default()(max) : undefined
            });
        case "time":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(hook_form/* RHFTimePicker */.Cm, {
                name: name,
                label: label,
                helperText: helperText,
                defaultValue: defaultValue,
                inputFormat: "HH:mm",
                minTime: min ? moment_default()(min) : undefined,
                maxTime: max ? moment_default()(max) : undefined
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
}

;// CONCATENATED MODULE: ./src/sections/landing/landingForm/index.tsx






















function LandingForm(props) {
    var ref, ref1;
    var contentfulDataFragment = props.contentfulDataFragment, backgroundColor = props.backgroundColor;
    var theme = (0,useTheme/* default */.Z)();
    var ref2 = (0,useAuth/* default */.Z)(), user = ref2.user, isAuthLoading = ref2.isLoading;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUserInsertFormMutation */.R9S)(), 1), userInsertFormMutation = ref3[0];
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var methods = (0,index_esm/* useForm */.cI)({
        defaultValues: {}
    });
    var handleSubmit = methods.handleSubmit, isSubmitting = methods.formState.isSubmitting;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var contentfulFormId, formDataCollection, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        contentfulFormId = contentfulDataFragment.sys.id;
                        formDataCollection = Object.entries(data).map(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                            return {
                                id: k,
                                type: (0,_instanceof/* default */.Z)(v, Date) ? "string" : typeof v === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(v),
                                value: (0,_instanceof/* default */.Z)(v, Date) ? moment_default()(v).format() : String(v)
                            };
                        });
                        return [
                            4,
                            userInsertFormMutation({
                                variables: {
                                    contentfulFormId: contentfulFormId,
                                    formAnswers: {
                                        data: formDataCollection.map(function(formData) {
                                            return {
                                                contentfulFormComponentId: formData.id,
                                                type: formData.type,
                                                value: formData.value
                                            };
                                        })
                                    }
                                }
                            }).then(function() {
                                return enqueueSnackbar("submit success", {
                                    variant: "success"
                                });
                            }).then(function() {
                                var ref;
                                var linePath = "https://line.me/R/ti/p/";
                                if ((ref = contentfulDataFragment.callToActionHref) === null || ref === void 0 ? void 0 : ref.includes(linePath)) {
                                    router.replace("line://ti/p/".concat(contentfulDataFragment.callToActionHref.replace(linePath, "")));
                                } else {
                                    var _callToActionHref;
                                    router.push((_callToActionHref = contentfulDataFragment.callToActionHref) !== null && _callToActionHref !== void 0 ? _callToActionHref : "/");
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        enqueueSnackbar("Submit failed, please submit again or contact us", {
                            variant: "error"
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref4;
    var formComponents = (ref4 = (ref = contentfulDataFragment.componentsCollection) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.filter(common/* notEmpty */.D)) !== null && ref4 !== void 0 ? ref4 : [];
    var _title, _description, _defaultValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            id: "form-section",
            component: animate/* MotionViewport */.DG,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                sx: {
                    p: 2.5
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* TopLandingSection */.k, {
                        title: (_title = contentfulDataFragment.title) !== null && _title !== void 0 ? _title : "",
                        subtitle: (_description = contentfulDataFragment.description) !== null && _description !== void 0 ? _description : ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(hook_form/* FormProvider */.RV, {
                        methods: methods,
                        onSubmit: handleSubmit(onSubmit),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 5,
                                children: formComponents === null || formComponents === void 0 ? void 0 : formComponents.map(function(formComponent) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        width: "100%",
                                        style: {
                                            padding: formComponent.type === "hidden" ? 0 : undefined
                                        },
                                        children: formComponent.type !== "email" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponent, {
                                            formComponent: formComponent
                                        }) : isAuthLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponent, {
                                            formComponent: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formComponent), {
                                                defaultValue: (_defaultValue = formComponent.defaultValue) !== null && _defaultValue !== void 0 ? _defaultValue : user === null || user === void 0 ? void 0 : user.email
                                            })
                                        })
                                    }, formComponent.sys.id);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                                sx: {
                                    mt: 3
                                },
                                fullWidth: true,
                                type: "submit",
                                variant: "contained",
                                loading: isSubmitting,
                                children: contentfulDataFragment.callToActionText
                            })
                        ]
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/landing/LandingImage.tsx







function LandingImage(props) {
    var contentfulDataFragment = props.contentfulDataFragment, backgroundColor = props.backgroundColor;
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    var _mobileImage;
    var imageObject = isMobile ? (_mobileImage = contentfulDataFragment.mobileImage) !== null && _mobileImage !== void 0 ? _mobileImage : contentfulDataFragment.image : contentfulDataFragment.image;
    var hasLink = Boolean(contentfulDataFragment.callToActionHref);
    var _callToActionHref, ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shares/* RootStyle */.i, {
        theme: theme,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            component: animate/* MotionViewport */.DG,
            children: (imageObject === null || imageObject === void 0 ? void 0 : imageObject.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: hasLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    href: (_callToActionHref = contentfulDataFragment.callToActionHref) !== null && _callToActionHref !== void 0 ? _callToActionHref : undefined,
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        alt: (ref = imageObject === null || imageObject === void 0 ? void 0 : imageObject.title) !== null && ref !== void 0 ? ref : "",
                        src: imageObject.url
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                    to: "form-section",
                    spy: true,
                    smooth: true,
                    offset: isMobile ? -80 : -110,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        alt: (ref1 = imageObject === null || imageObject === void 0 ? void 0 : imageObject.title) !== null && ref1 !== void 0 ? ref1 : "",
                        src: imageObject.url
                    })
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/landing/index.ts

















/***/ }),

/***/ 28285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ renderComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/sections/landing/index.ts + 24 modules
var landing = __webpack_require__(82290);
;// CONCATENATED MODULE: ./src/services/pageEnum.ts
var ContentfulSectionName;
(function(ContentfulSectionName) {
    ContentfulSectionName["SectionsHero"] = "SectionsHero";
    ContentfulSectionName["SectionsMinimalsVideo"] = "SectionsMinimalsVideo";
    ContentfulSectionName["SectionsMinimalsServices"] = "SectionsMinimalsServices";
    ContentfulSectionName["SectionsMinimalsImagesList"] = "SectionsMinimalsImagesList";
    ContentfulSectionName["SectionsMinimalsHumanList"] = "SectionsMinimalsHumanList";
    ContentfulSectionName["SectionsDetailPersonList"] = "SectionsDetailPersonList";
    ContentfulSectionName["SectionsFaqList"] = "SectionsFaqList";
    ContentfulSectionName["SectionsMinimalsHistoryList"] = "SectionsMinimalsHistoryList";
    ContentfulSectionName["SectionsMinimalsContactList"] = "SectionsMinimalsContactList";
    ContentfulSectionName["SectionsFeaturesList"] = "SectionsFeaturesList";
    ContentfulSectionName["SectionsMintList"] = "SectionsMintList";
    ContentfulSectionName["SectionsTimer"] = "SectionsTimer";
    ContentfulSectionName["SectionsMinimalsGallery"] = "SectionsMinimalsGallery";
    ContentfulSectionName["SectionsForm"] = "SectionsForm";
    ContentfulSectionName["SectionsImage"] = "SectionsImage";
})(ContentfulSectionName || (ContentfulSectionName = {}));

;// CONCATENATED MODULE: ./src/services/pageRender.tsx



var renderComponent = function(section, sectionBackgroundColors, index, globalSetting) {
    switch(section.key){
        case ContentfulSectionName.SectionsFeaturesList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingFeaturesList */.LF, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length],
                globalSetting: globalSetting
            }, section.key + index);
        case ContentfulSectionName.SectionsMinimalsVideo:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingVideo */.Nn, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        case ContentfulSectionName.SectionsMinimalsServices:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingService */.Uo, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        case ContentfulSectionName.SectionsMinimalsImagesList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingImageList */.K9, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        case ContentfulSectionName.SectionsMinimalsHumanList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingHumanList */.qU, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        case ContentfulSectionName.SectionsDetailPersonList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingDetailPersonList */.J7, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        case ContentfulSectionName.SectionsFaqList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingFaqList */.Xg, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        case ContentfulSectionName.SectionsMinimalsHistoryList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingExperienceTimeline */.B5, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        case ContentfulSectionName.SectionsMintList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingMintList */.TJ, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        case ContentfulSectionName.SectionsMinimalsGallery:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingGallery */.K, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        case ContentfulSectionName.SectionsMinimalsContactList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingContact */.X0, {
                contentfulDataFragment: section
            }, section.key + index);
        case ContentfulSectionName.SectionsTimer:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingTimer */.uY, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        case ContentfulSectionName.SectionsForm:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingForm */.wU, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        case ContentfulSectionName.SectionsImage:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing/* LandingImage */.n9, {
                contentfulDataFragment: section,
                backgroundColor: sectionBackgroundColors[index % sectionBackgroundColors.length]
            }, section.key + index);
        default:
            return null;
    }
};


/***/ }),

/***/ 76271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eh": function() { return /* binding */ decodeID; },
/* harmony export */   "J1": function() { return /* binding */ formatPromptsPageUrl; },
/* harmony export */   "Pb": function() { return /* binding */ formatPrompt; },
/* harmony export */   "SP": function() { return /* binding */ currentConcurrentCountVar; },
/* harmony export */   "U9": function() { return /* binding */ shouldDisableMagicButton; },
/* harmony export */   "_7": function() { return /* binding */ UseCase; },
/* harmony export */   "fW": function() { return /* binding */ systemLocaleTransformer; },
/* harmony export */   "k9": function() { return /* binding */ PlanType; },
/* harmony export */   "kt": function() { return /* binding */ getConcurrentCountByPlanType; },
/* harmony export */   "uj": function() { return /* binding */ languageTransformer; }
/* harmony export */ });
/* unused harmony exports encodeID, plans, constantPromptTransform, getPromptFromStaticPrompt, midjourneyPromptParamsVersionMap, getCreateImagePrompt */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _appConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83330);
/* harmony import */ var _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98968);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34088);
/* harmony import */ var buffer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48764);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15983);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_4__);







var PlanType;
(function(PlanType) {
    PlanType["free"] = "free";
    PlanType["basic"] = "basic";
    PlanType["premium"] = "premium";
})(PlanType || (PlanType = {}));
// Function to encode ID
function encodeID(id) {
    var buffer = Buffer.from(id, "utf-8");
    return buffer.toString("base64");
}
// Function to decode ID
function decodeID(encodedId) {
    var buffer = buffer__WEBPACK_IMPORTED_MODULE_3__.Buffer.from(encodedId, "base64");
    return buffer.toString("utf-8");
}
var plans = [
    {
        type: PlanType.free,
        concurrent: 3
    },
    {
        type: PlanType.basic,
        concurrent: 5
    },
    {
        type: PlanType.premium,
        concurrent: 7
    }, 
];
var ref;
var getConcurrentCountByPlanType = function(planType) {
    var ref1;
    return (ref = (ref1 = lodash_find__WEBPACK_IMPORTED_MODULE_4___default()(plans, {
        type: planType
    })) === null || ref1 === void 0 ? void 0 : ref1.concurrent) !== null && ref !== void 0 ? ref : 1;
};
var shouldDisableMagicButton = function(params) {
    var ref;
    var planType = params.planType, currentConcurrentCount = params.currentConcurrentCount;
    var ref1;
    return ((ref1 = (ref = lodash_find__WEBPACK_IMPORTED_MODULE_4___default()(plans, {
        type: planType
    })) === null || ref === void 0 ? void 0 : ref.concurrent) !== null && ref1 !== void 0 ? ref1 : 1) <= currentConcurrentCount;
};
var currentConcurrentCountVar = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .makeVar */ .QS)(0);
var languageTransformer = function(language) {
    return {
        label: language === _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__/* .PromptSupportingLanguageMap.MandarinChinese */ .aN.MandarinChinese ? "Mandarin Chinese" : language,
        id: language,
        value: language
    };
};
var formatPromptsPageUrl = function(params) {
    return "/app/".concat(_appConfig__WEBPACK_IMPORTED_MODULE_0__/* .AppServiceEnum.prompts */ .$3.prompts, "?").concat(query_string__WEBPACK_IMPORTED_MODULE_2__/* ["default"].stringify */ .Z.stringify((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, params)));
};
var UseCase;
(function(UseCase) {
    UseCase["text"] = "text";
    UseCase["image"] = "image";
    UseCase["video"] = "video";
})(UseCase || (UseCase = {}));
var constantPromptTransform = function(prompt) {
    return {
        id: prompt.ID,
        prompt: prompt.Prompt,
        promptHint: prompt.PromptHint,
        promptTeaser: prompt.Teaser,
        createdAt: prompt.CreationTime,
        updatedAt: prompt.RevisionTime,
        statistics: {
            usages: prompt.Usages,
            views: prompt.Views,
            votes: prompt.Votes
        }
    };
};
var getPromptFromStaticPrompt = function(params) {
    var staticPrompt = params.staticPrompt, userPrompt = params.userPrompt, language = params.language, _tags = params.tags, tags = _tags === void 0 ? [] : _tags;
    var result = staticPrompt.Prompt.replace(/\[Please ignore all previous instructions\]/g, "").replace(/\[TARGETLANGUAGE\]/g, language).replace(/\[PROMPT\]/g, userPrompt).replace(/\[TAGS\]/g, tags.join(", "));
    return result;
};
var formatPrompt = function(params) {
    var promptString = params.promptString, language = params.language, userPrompt = params.userPrompt, writeStyle = params.writeStyle, responseTone = params.responseTone;
    var result = promptString.replace(/\[TARGETLANGUAGE\]/g, language).replace(/\[PROMPT\]/g, userPrompt);
    var textToAddAtTheEnd = "\n  ".concat(writeStyle ? "The writing style should be ".concat(writeStyle, " and is written by a human") : "", "\n  ").concat(responseTone ? "The response tone should be ".concat(responseTone, " and is written by a human") : "", "\n  \n  ");
    return "".concat(result, "\n  ").concat(textToAddAtTheEnd, "\n  ").trim();
};
var midjourneyPromptParamsVersionMap;
(function(midjourneyPromptParamsVersionMap) {
    midjourneyPromptParamsVersionMap["v1"] = "v1";
    midjourneyPromptParamsVersionMap["v2"] = "v2";
})(midjourneyPromptParamsVersionMap || (midjourneyPromptParamsVersionMap = {}));
var getCreateImagePrompt = function(params) {
    var concept = params.concept, version = params.version;
    var latestMagicString = "\nwrite without wordwraps, headlines, connection words. Write back to back separated with commas and spaces:\n[1], [2], [3], [4], [5], [6]\n\nreplace [1] with a ".concat(concept, '\nreplace [2] with a concise, descriptive summary of [1]. Ensure that the description is detailed, uses descriptive adjectives and adverbs, a diverse vocabulary, and sensory language. Offer context and background information regarding the subject and consider the image\'s perspective and point of view. Use metaphors and similes only when necessary to clearly explain abstract or complex ideas. Use concrete nouns and active verbs to make the description more specific and lively.\nreplace [3] with a concise summary of the scene\'s environment. Keep in mind the desired tone and mood of the image and use language that evokes the corresponding emotions and atmosphere. Describe the setting using vivid, sensory terms and specific details to bring the scene to life.\nreplace [4] with a concise description of the mood of the scene, using language that conveys the desired emotions and atmosphere.\nreplace [5] with a concise description of the atmosphere, using descriptive adjectives and adverbs to create the desired atmosphere while considering the overall tone and mood of the image.\nreplace [6] with a concise description of the lighting effect, including types of lights, displays, styles, techniques, global illumination, and shadows. Describe the quality, direction, color, and intensity of the light and how it impacts the mood and atmosphere of the scene. Use specific adjectives and adverbs to portray the desired lighting effect and consider how it will interact with the subject and environment.\n\nEnsure word count limit of 1,500 words\nThe prompt should include the end arguments "--c X --s Y --q 2," where X is a whole number between 1 and 25 and Y is a whole number between 100 and 1000. \nIf the subject looks better vertically, add "--ar 2:3" before "--c," and if it looks better horizontally, add "--ar 3:2" before "--c." \nPlease randomize the end argument format and fix "--q 2." \nDo not use double quotation marks or punctuation marks, and use a randomized end suffix format.\nStart the prompt with exact words of "/imagine prompt: "\n\nnow generate the prompt in English*\n    ');
    var magicStr = "";
    switch(version){
        case midjourneyPromptParamsVersionMap.v1:
            {
                magicStr = "\nwrite without wordwraps, headlines, connection words. Write back to back separated with commas and spaces:\n\n[1], [2], [3], [4], [5]\n\nreplace [1] with a ".concat(concept, '\nreplace [2] with a list of detailed descriptions about [1]\nreplace [3] with a list of detailed descriptions about the environment of the scene\nreplace [4] with a list of detailed descriptions about the mood/feelings and atmosphere of the scene\nreplace [5] with a list of detailed descriptions about the way the prompt should be realized (e.g. Photography (e.g. Macro, Fisheye Style, Portrait) with camera model and according settings, Painting with detailed descriptions about the materials and working material used, rendering with engine settings, a digital Illustration, a woodburn art (and everything else that could be defined as an output type)\n\nshort prompt for an AI-based text to image program that converts a prompt about a topic into an image. Combine a wide variety of rare and commonly used words.\n\nalways start the prompt with "/imagine prompt: "\nalways end the prompt with " --v 4"\nnever write anything that is in [] brackets\ndon\'t use any line breaks\n\nwhen the prompt subject looks better vertically, add "--ar 2:3" before "--v 4".\nWhen the subject looks better horizontally, use "--ar 3:2" instead.\nWhen the subject looks better in a square, use "--ar 1:1" instead.\n\nnow generate the prompt in English*\n      ');
                break;
            }
        case midjourneyPromptParamsVersionMap.v2:
            {
                magicStr = '\n"Create an "imagine prompt" with a word count limit of 1,500 words for the AI-based text-to-image program MidJourney using the following parameters: /imagine prompt: [1], [2], [3], [4], [5], [6].\n\nIn this prompt, [1] should be replaced with a user-supplied concept and [2] should be a concise, descriptive summary of the subject. Ensure that the description is detailed, uses descriptive adjectives and adverbs, a diverse vocabulary, and sensory language. Offer context and background information regarding the subject and consider the image\'s perspective and point of view. Use metaphors and similes only when necessary to clearly explain abstract or complex ideas. Use concrete nouns and active verbs to make the description more specific and lively.\n\n[3] should be a concise summary of the scene\'s environment. Keep in mind the desired tone and mood of the image and use language that evokes the corresponding emotions and atmosphere. Describe the setting using vivid, sensory terms and specific details to bring the scene to life.\n\n[4] should be a concise description of the mood of the scene, using language that conveys the desired emotions and atmosphere.\n\n[5] should be a concise description of the atmosphere, using descriptive adjectives and adverbs to create the desired atmosphere while considering the overall tone and mood of the image.\n\n[6] should be a concise description of the lighting effect, including types of lights, displays, styles, techniques, global illumination, and shadows. Describe the quality, direction, color, and intensity of the light and how it impacts the mood and atmosphere of the scene. Use specific adjectives and adverbs to portray the desired lighting effect and consider how it will interact with the subject and environment.\n\nIt\'s important to remember that the descriptions in the prompt should be written together, separated only by commas and spaces, and should not contain any line breaks or colons. Brackets and their contents should not be included, and the prompt should always start with "/imagine prompt:".\n\nEnsure that the grammar is consistent and avoid using cliches or excess words. Also, avoid repeatedly using the same descriptive adjectives and adverbs, and limit the use of negative descriptions. Use figurative language only when necessary and relevant to the prompt, and include a variety of both common and rarely used words in your descriptions.\n\nThe "imagine prompt" must not exceed 1,500 words. The prompt should include the end arguments "--c X --s Y --q 2," where X is a whole number between 1 and 25 and Y is a whole number between 100 and 1000. If the subject looks better vertically, add "--ar 2:3" before "--c," and if it looks better horizontally, add "--ar 3:2" before "--c." Please randomize the end argument format and fix "--q 2." Donot use double quotation marks or punctuation marks, and use a randomized end suffix format.\n\nWait for a '.concat(concept, ' to be provided before generating the prompt."\n      ');
                break;
            }
        default:
            {
                magicStr = latestMagicString;
            }
    }
    return magicStr;
};
var systemLocaleTransformer = function(locale) {
    switch(locale){
        case _appConfig__WEBPACK_IMPORTED_MODULE_0__/* .SupportLocaleEnum.en */ .xM.en:
            return _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__/* .PromptSupportingLanguageMap.English */ .aN.English;
        case _appConfig__WEBPACK_IMPORTED_MODULE_0__/* .SupportLocaleEnum.zhTw */ .xM.zhTw:
            return _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__/* .PromptSupportingLanguageMap.MandarinChinese */ .aN.MandarinChinese;
        case _appConfig__WEBPACK_IMPORTED_MODULE_0__/* .SupportLocaleEnum.ja */ .xM.ja:
            return _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__/* .PromptSupportingLanguageMap.Japanese */ .aN.Japanese;
        default:
            return _generated_graphql_prompts_node__WEBPACK_IMPORTED_MODULE_1__/* .PromptSupportingLanguageMap.English */ .aN.English;
    }
};


/***/ }),

/***/ 20474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ notEmpty; }
/* harmony export */ });
var notEmpty = function(value) {
    return value !== null && value !== undefined;
};


/***/ }),

/***/ 13135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ SHARED_PROMPT_HEADER_FOR_HERO_SECTION; },
/* harmony export */   "r": function() { return /* binding */ SHARED_PROMPT_HEADER_FOR_CUSTOM_PROMPT_ENGINEERING; }
/* harmony export */ });
var SHARED_PROMPT_HEADER_FOR_HERO_SECTION = "sections-minimals-hero-id";
var SHARED_PROMPT_HEADER_FOR_CUSTOM_PROMPT_ENGINEERING = "sections-special-engineering-id";


/***/ })

}]);